import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  json: any;
  jsonb: any;
  numeric: any;
  priority_enum: any;
  timestamptz: any;
};

/** use to keep track of status of bids */
export type BidStatus = {
  __typename?: 'BidStatus';
  /** An array relationship */
  Bids: Array<Bids>;
  /** An aggregate relationship */
  Bids_aggregate: Bids_Aggregate;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


/** use to keep track of status of bids */
export type BidStatusBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** use to keep track of status of bids */
export type BidStatusBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};

/** aggregated selection of "BidStatus" */
export type BidStatus_Aggregate = {
  __typename?: 'BidStatus_aggregate';
  aggregate?: Maybe<BidStatus_Aggregate_Fields>;
  nodes: Array<BidStatus>;
};

/** aggregate fields of "BidStatus" */
export type BidStatus_Aggregate_Fields = {
  __typename?: 'BidStatus_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<BidStatus_Max_Fields>;
  min?: Maybe<BidStatus_Min_Fields>;
};


/** aggregate fields of "BidStatus" */
export type BidStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BidStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "BidStatus". All fields are combined with a logical 'AND'. */
export type BidStatus_Bool_Exp = {
  Bids?: InputMaybe<Bids_Bool_Exp>;
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<BidStatus_Bool_Exp>>;
  _not?: InputMaybe<BidStatus_Bool_Exp>;
  _or?: InputMaybe<Array<BidStatus_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "BidStatus" */
export enum BidStatus_Constraint {
  /** unique or primary key constraint on columns "name" */
  BidStatusNameKey = 'BidStatus_name_key',
  /** unique or primary key constraint on columns "name" */
  BidStatusPkey = 'BidStatus_pkey'
}

export enum BidStatus_Enum {
  Approved = 'APPROVED',
  /** Bids they are getting paid for */
  Executed = 'EXECUTED',
  Expired = 'EXPIRED',
  Hidden = 'HIDDEN',
  Submitted = 'SUBMITTED'
}

/** Boolean expression to compare columns of type "BidStatus_enum". All fields are combined with logical 'AND'. */
export type BidStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<BidStatus_Enum>;
  _in?: InputMaybe<Array<BidStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BidStatus_Enum>;
  _nin?: InputMaybe<Array<BidStatus_Enum>>;
};

/** input type for inserting data into table "BidStatus" */
export type BidStatus_Insert_Input = {
  Bids?: InputMaybe<Bids_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BidStatus_Max_Fields = {
  __typename?: 'BidStatus_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BidStatus_Min_Fields = {
  __typename?: 'BidStatus_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "BidStatus" */
export type BidStatus_Mutation_Response = {
  __typename?: 'BidStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BidStatus>;
};

/** input type for inserting object relation for remote table "BidStatus" */
export type BidStatus_Obj_Rel_Insert_Input = {
  data: BidStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BidStatus_On_Conflict>;
};

/** on_conflict condition type for table "BidStatus" */
export type BidStatus_On_Conflict = {
  constraint: BidStatus_Constraint;
  update_columns?: Array<BidStatus_Update_Column>;
  where?: InputMaybe<BidStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "BidStatus". */
export type BidStatus_Order_By = {
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: BidStatus */
export type BidStatus_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "BidStatus" */
export enum BidStatus_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "BidStatus" */
export type BidStatus_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "BidStatus" */
export type BidStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BidStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BidStatus_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "BidStatus" */
export enum BidStatus_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type BidStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BidStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: BidStatus_Bool_Exp;
};

/** columns and relationships of "Bids" */
export type Bids = {
  __typename?: 'Bids';
  /** An object relationship */
  BidStatus: BidStatus;
  /** An object relationship */
  Bids_private_info?: Maybe<Bids_Private>;
  /** An object relationship */
  Collection: Collections;
  /** An object relationship */
  Deal: Deals;
  /** An object relationship */
  User: Users;
  agreementHash: Scalars['String'];
  bid_amount: Scalars['String'];
  bid_expiration?: Maybe<Scalars['timestamptz']>;
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  deal_id: Scalars['Int'];
  id: Scalars['Int'];
  nft_contract_address: Scalars['String'];
  status: BidStatus_Enum;
  token_id: Scalars['String'];
  tx_hash?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  wallet_address: Scalars['String'];
};

/** aggregated selection of "Bids" */
export type Bids_Aggregate = {
  __typename?: 'Bids_aggregate';
  aggregate?: Maybe<Bids_Aggregate_Fields>;
  nodes: Array<Bids>;
};

export type Bids_Aggregate_Bool_Exp = {
  count?: InputMaybe<Bids_Aggregate_Bool_Exp_Count>;
};

export type Bids_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bids_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Bids_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Bids" */
export type Bids_Aggregate_Fields = {
  __typename?: 'Bids_aggregate_fields';
  avg?: Maybe<Bids_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bids_Max_Fields>;
  min?: Maybe<Bids_Min_Fields>;
  stddev?: Maybe<Bids_Stddev_Fields>;
  stddev_pop?: Maybe<Bids_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bids_Stddev_Samp_Fields>;
  sum?: Maybe<Bids_Sum_Fields>;
  var_pop?: Maybe<Bids_Var_Pop_Fields>;
  var_samp?: Maybe<Bids_Var_Samp_Fields>;
  variance?: Maybe<Bids_Variance_Fields>;
};


/** aggregate fields of "Bids" */
export type Bids_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bids_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Bids" */
export type Bids_Aggregate_Order_By = {
  avg?: InputMaybe<Bids_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bids_Max_Order_By>;
  min?: InputMaybe<Bids_Min_Order_By>;
  stddev?: InputMaybe<Bids_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bids_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bids_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bids_Sum_Order_By>;
  var_pop?: InputMaybe<Bids_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bids_Var_Samp_Order_By>;
  variance?: InputMaybe<Bids_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Bids" */
export type Bids_Arr_Rel_Insert_Input = {
  data: Array<Bids_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bids_On_Conflict>;
};

/** aggregate avg on columns */
export type Bids_Avg_Fields = {
  __typename?: 'Bids_avg_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Bids" */
export type Bids_Avg_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Bids". All fields are combined with a logical 'AND'. */
export type Bids_Bool_Exp = {
  BidStatus?: InputMaybe<BidStatus_Bool_Exp>;
  Bids_private_info?: InputMaybe<Bids_Private_Bool_Exp>;
  Collection?: InputMaybe<Collections_Bool_Exp>;
  Deal?: InputMaybe<Deals_Bool_Exp>;
  User?: InputMaybe<Users_Bool_Exp>;
  _and?: InputMaybe<Array<Bids_Bool_Exp>>;
  _not?: InputMaybe<Bids_Bool_Exp>;
  _or?: InputMaybe<Array<Bids_Bool_Exp>>;
  agreementHash?: InputMaybe<String_Comparison_Exp>;
  bid_amount?: InputMaybe<String_Comparison_Exp>;
  bid_expiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  bid_percentage_amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deal_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nft_contract_address?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<BidStatus_Enum_Comparison_Exp>;
  token_id?: InputMaybe<String_Comparison_Exp>;
  tx_hash?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Bids" */
export enum Bids_Constraint {
  /** unique or primary key constraint on columns "agreementHash" */
  BidsAgreementHashKey = 'Bids_agreementHash_key',
  /** unique or primary key constraint on columns "id" */
  BidsPkey = 'Bids_pkey',
  /** unique or primary key constraint on columns "tx_hash" */
  BidsTxHashKey = 'Bids_tx_hash_key',
  /** unique or primary key constraint on columns "nft_contract_address", "token_id", "deal_id" */
  UniqueBids = 'unique_bids'
}

/** input type for incrementing numeric columns in table "Bids" */
export type Bids_Inc_Input = {
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Bids" */
export type Bids_Insert_Input = {
  BidStatus?: InputMaybe<BidStatus_Obj_Rel_Insert_Input>;
  Bids_private_info?: InputMaybe<Bids_Private_Obj_Rel_Insert_Input>;
  Collection?: InputMaybe<Collections_Obj_Rel_Insert_Input>;
  Deal?: InputMaybe<Deals_Obj_Rel_Insert_Input>;
  User?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  agreementHash?: InputMaybe<Scalars['String']>;
  bid_amount?: InputMaybe<Scalars['String']>;
  bid_expiration?: InputMaybe<Scalars['timestamptz']>;
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BidStatus_Enum>;
  token_id?: InputMaybe<Scalars['String']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Bids_Max_Fields = {
  __typename?: 'Bids_max_fields';
  agreementHash?: Maybe<Scalars['String']>;
  bid_amount?: Maybe<Scalars['String']>;
  bid_expiration?: Maybe<Scalars['timestamptz']>;
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Bids" */
export type Bids_Max_Order_By = {
  agreementHash?: InputMaybe<Order_By>;
  bid_amount?: InputMaybe<Order_By>;
  bid_expiration?: InputMaybe<Order_By>;
  bid_percentage_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bids_Min_Fields = {
  __typename?: 'Bids_min_fields';
  agreementHash?: Maybe<Scalars['String']>;
  bid_amount?: Maybe<Scalars['String']>;
  bid_expiration?: Maybe<Scalars['timestamptz']>;
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  tx_hash?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Bids" */
export type Bids_Min_Order_By = {
  agreementHash?: InputMaybe<Order_By>;
  bid_amount?: InputMaybe<Order_By>;
  bid_expiration?: InputMaybe<Order_By>;
  bid_percentage_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Bids" */
export type Bids_Mutation_Response = {
  __typename?: 'Bids_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bids>;
};

/** on_conflict condition type for table "Bids" */
export type Bids_On_Conflict = {
  constraint: Bids_Constraint;
  update_columns?: Array<Bids_Update_Column>;
  where?: InputMaybe<Bids_Bool_Exp>;
};

/** Ordering options when selecting data from "Bids". */
export type Bids_Order_By = {
  BidStatus?: InputMaybe<BidStatus_Order_By>;
  Bids_private_info?: InputMaybe<Bids_Private_Order_By>;
  Collection?: InputMaybe<Collections_Order_By>;
  Deal?: InputMaybe<Deals_Order_By>;
  User?: InputMaybe<Users_Order_By>;
  agreementHash?: InputMaybe<Order_By>;
  bid_amount?: InputMaybe<Order_By>;
  bid_expiration?: InputMaybe<Order_By>;
  bid_percentage_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  token_id?: InputMaybe<Order_By>;
  tx_hash?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Bids */
export type Bids_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "Bids_private" */
export type Bids_Private = {
  __typename?: 'Bids_private';
  agreementHash?: Maybe<Scalars['String']>;
  bid_amount?: Maybe<Scalars['String']>;
  bid_expiration?: Maybe<Scalars['timestamptz']>;
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** aggregated selection of "Bids_private" */
export type Bids_Private_Aggregate = {
  __typename?: 'Bids_private_aggregate';
  aggregate?: Maybe<Bids_Private_Aggregate_Fields>;
  nodes: Array<Bids_Private>;
};

/** aggregate fields of "Bids_private" */
export type Bids_Private_Aggregate_Fields = {
  __typename?: 'Bids_private_aggregate_fields';
  avg?: Maybe<Bids_Private_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bids_Private_Max_Fields>;
  min?: Maybe<Bids_Private_Min_Fields>;
  stddev?: Maybe<Bids_Private_Stddev_Fields>;
  stddev_pop?: Maybe<Bids_Private_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bids_Private_Stddev_Samp_Fields>;
  sum?: Maybe<Bids_Private_Sum_Fields>;
  var_pop?: Maybe<Bids_Private_Var_Pop_Fields>;
  var_samp?: Maybe<Bids_Private_Var_Samp_Fields>;
  variance?: Maybe<Bids_Private_Variance_Fields>;
};


/** aggregate fields of "Bids_private" */
export type Bids_Private_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bids_Private_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Bids_Private_Avg_Fields = {
  __typename?: 'Bids_private_avg_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Bids_private". All fields are combined with a logical 'AND'. */
export type Bids_Private_Bool_Exp = {
  _and?: InputMaybe<Array<Bids_Private_Bool_Exp>>;
  _not?: InputMaybe<Bids_Private_Bool_Exp>;
  _or?: InputMaybe<Array<Bids_Private_Bool_Exp>>;
  agreementHash?: InputMaybe<String_Comparison_Exp>;
  bid_amount?: InputMaybe<String_Comparison_Exp>;
  bid_expiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  bid_percentage_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deal_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "Bids_private" */
export type Bids_Private_Inc_Input = {
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Bids_private" */
export type Bids_Private_Insert_Input = {
  agreementHash?: InputMaybe<Scalars['String']>;
  bid_amount?: InputMaybe<Scalars['String']>;
  bid_expiration?: InputMaybe<Scalars['timestamptz']>;
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Bids_Private_Max_Fields = {
  __typename?: 'Bids_private_max_fields';
  agreementHash?: Maybe<Scalars['String']>;
  bid_amount?: Maybe<Scalars['String']>;
  bid_expiration?: Maybe<Scalars['timestamptz']>;
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Bids_Private_Min_Fields = {
  __typename?: 'Bids_private_min_fields';
  agreementHash?: Maybe<Scalars['String']>;
  bid_amount?: Maybe<Scalars['String']>;
  bid_expiration?: Maybe<Scalars['timestamptz']>;
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Bids_private" */
export type Bids_Private_Mutation_Response = {
  __typename?: 'Bids_private_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bids_Private>;
};

/** input type for inserting object relation for remote table "Bids_private" */
export type Bids_Private_Obj_Rel_Insert_Input = {
  data: Bids_Private_Insert_Input;
};

/** Ordering options when selecting data from "Bids_private". */
export type Bids_Private_Order_By = {
  agreementHash?: InputMaybe<Order_By>;
  bid_amount?: InputMaybe<Order_By>;
  bid_expiration?: InputMaybe<Order_By>;
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** select columns of table "Bids_private" */
export enum Bids_Private_Select_Column {
  /** column name */
  AgreementHash = 'agreementHash',
  /** column name */
  BidAmount = 'bid_amount',
  /** column name */
  BidExpiration = 'bid_expiration',
  /** column name */
  BidPercentageAmount = 'bid_percentage_amount',
  /** column name */
  DealId = 'deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** input type for updating data in table "Bids_private" */
export type Bids_Private_Set_Input = {
  agreementHash?: InputMaybe<Scalars['String']>;
  bid_amount?: InputMaybe<Scalars['String']>;
  bid_expiration?: InputMaybe<Scalars['timestamptz']>;
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Bids_Private_Stddev_Fields = {
  __typename?: 'Bids_private_stddev_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bids_Private_Stddev_Pop_Fields = {
  __typename?: 'Bids_private_stddev_pop_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bids_Private_Stddev_Samp_Fields = {
  __typename?: 'Bids_private_stddev_samp_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Bids_private" */
export type Bids_Private_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bids_Private_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bids_Private_Stream_Cursor_Value_Input = {
  agreementHash?: InputMaybe<Scalars['String']>;
  bid_amount?: InputMaybe<Scalars['String']>;
  bid_expiration?: InputMaybe<Scalars['timestamptz']>;
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Bids_Private_Sum_Fields = {
  __typename?: 'Bids_private_sum_fields';
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Bids_Private_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bids_Private_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bids_Private_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bids_Private_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bids_Private_Var_Pop_Fields = {
  __typename?: 'Bids_private_var_pop_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bids_Private_Var_Samp_Fields = {
  __typename?: 'Bids_private_var_samp_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bids_Private_Variance_Fields = {
  __typename?: 'Bids_private_variance_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** select columns of table "Bids" */
export enum Bids_Select_Column {
  /** column name */
  AgreementHash = 'agreementHash',
  /** column name */
  BidAmount = 'bid_amount',
  /** column name */
  BidExpiration = 'bid_expiration',
  /** column name */
  BidPercentageAmount = 'bid_percentage_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DealId = 'deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  Status = 'status',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** input type for updating data in table "Bids" */
export type Bids_Set_Input = {
  agreementHash?: InputMaybe<Scalars['String']>;
  bid_amount?: InputMaybe<Scalars['String']>;
  bid_expiration?: InputMaybe<Scalars['timestamptz']>;
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BidStatus_Enum>;
  token_id?: InputMaybe<Scalars['String']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Bids_Stddev_Fields = {
  __typename?: 'Bids_stddev_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Bids" */
export type Bids_Stddev_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bids_Stddev_Pop_Fields = {
  __typename?: 'Bids_stddev_pop_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Bids" */
export type Bids_Stddev_Pop_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bids_Stddev_Samp_Fields = {
  __typename?: 'Bids_stddev_samp_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Bids" */
export type Bids_Stddev_Samp_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Bids" */
export type Bids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bids_Stream_Cursor_Value_Input = {
  agreementHash?: InputMaybe<Scalars['String']>;
  bid_amount?: InputMaybe<Scalars['String']>;
  bid_expiration?: InputMaybe<Scalars['timestamptz']>;
  bid_percentage_amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BidStatus_Enum>;
  token_id?: InputMaybe<Scalars['String']>;
  tx_hash?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Bids_Sum_Fields = {
  __typename?: 'Bids_sum_fields';
  bid_percentage_amount?: Maybe<Scalars['numeric']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "Bids" */
export type Bids_Sum_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "Bids" */
export enum Bids_Update_Column {
  /** column name */
  AgreementHash = 'agreementHash',
  /** column name */
  BidAmount = 'bid_amount',
  /** column name */
  BidExpiration = 'bid_expiration',
  /** column name */
  BidPercentageAmount = 'bid_percentage_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DealId = 'deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  Status = 'status',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  TxHash = 'tx_hash',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletAddress = 'wallet_address'
}

export type Bids_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bids_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bids_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bids_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bids_Var_Pop_Fields = {
  __typename?: 'Bids_var_pop_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Bids" */
export type Bids_Var_Pop_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bids_Var_Samp_Fields = {
  __typename?: 'Bids_var_samp_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Bids" */
export type Bids_Var_Samp_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bids_Variance_Fields = {
  __typename?: 'Bids_variance_fields';
  bid_percentage_amount?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Bids" */
export type Bids_Variance_Order_By = {
  bid_percentage_amount?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "Brands" */
export type Brands = {
  __typename?: 'Brands';
  /** An object relationship */
  Brands_private_info?: Maybe<Brands_Private>;
  /** An array relationship */
  Deals: Array<Deals>;
  /** An aggregate relationship */
  Deals_aggregate: Deals_Aggregate;
  /** An object relationship */
  User: Users;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  physical_address?: Maybe<Scalars['String']>;
  position_at_company?: Maybe<Scalars['String']>;
  royalty_opp_enabled?: Maybe<Scalars['Boolean']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  wallet_address: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Brands" */
export type BrandsDealsArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


/** columns and relationships of "Brands" */
export type BrandsDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};

/** aggregated selection of "Brands" */
export type Brands_Aggregate = {
  __typename?: 'Brands_aggregate';
  aggregate?: Maybe<Brands_Aggregate_Fields>;
  nodes: Array<Brands>;
};

/** aggregate fields of "Brands" */
export type Brands_Aggregate_Fields = {
  __typename?: 'Brands_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Brands_Max_Fields>;
  min?: Maybe<Brands_Min_Fields>;
};


/** aggregate fields of "Brands" */
export type Brands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Brands". All fields are combined with a logical 'AND'. */
export type Brands_Bool_Exp = {
  Brands_private_info?: InputMaybe<Brands_Private_Bool_Exp>;
  Deals?: InputMaybe<Deals_Bool_Exp>;
  Deals_aggregate?: InputMaybe<Deals_Aggregate_Bool_Exp>;
  User?: InputMaybe<Users_Bool_Exp>;
  _and?: InputMaybe<Array<Brands_Bool_Exp>>;
  _not?: InputMaybe<Brands_Bool_Exp>;
  _or?: InputMaybe<Array<Brands_Bool_Exp>>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  legal_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  physical_address?: InputMaybe<String_Comparison_Exp>;
  position_at_company?: InputMaybe<String_Comparison_Exp>;
  royalty_opp_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Brands" */
export enum Brands_Constraint {
  /** unique or primary key constraint on columns "wallet_address" */
  BrandsPkey = 'Brands_pkey',
  /** unique or primary key constraint on columns "username" */
  BrandsUsernameKey = 'Brands_username_key',
  /** unique or primary key constraint on columns "wallet_address" */
  BrandsWalletAddressKey = 'Brands_wallet_address_key'
}

/** input type for inserting data into table "Brands" */
export type Brands_Insert_Input = {
  Brands_private_info?: InputMaybe<Brands_Private_Obj_Rel_Insert_Input>;
  Deals?: InputMaybe<Deals_Arr_Rel_Insert_Input>;
  User?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  physical_address?: InputMaybe<Scalars['String']>;
  position_at_company?: InputMaybe<Scalars['String']>;
  royalty_opp_enabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Brands_Max_Fields = {
  __typename?: 'Brands_max_fields';
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  physical_address?: Maybe<Scalars['String']>;
  position_at_company?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Brands_Min_Fields = {
  __typename?: 'Brands_min_fields';
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  physical_address?: Maybe<Scalars['String']>;
  position_at_company?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Brands" */
export type Brands_Mutation_Response = {
  __typename?: 'Brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Brands>;
};

/** input type for inserting object relation for remote table "Brands" */
export type Brands_Obj_Rel_Insert_Input = {
  data: Brands_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brands_On_Conflict>;
};

/** on_conflict condition type for table "Brands" */
export type Brands_On_Conflict = {
  constraint: Brands_Constraint;
  update_columns?: Array<Brands_Update_Column>;
  where?: InputMaybe<Brands_Bool_Exp>;
};

/** Ordering options when selecting data from "Brands". */
export type Brands_Order_By = {
  Brands_private_info?: InputMaybe<Brands_Private_Order_By>;
  Deals_aggregate?: InputMaybe<Deals_Aggregate_Order_By>;
  User?: InputMaybe<Users_Order_By>;
  company_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  physical_address?: InputMaybe<Order_By>;
  position_at_company?: InputMaybe<Order_By>;
  royalty_opp_enabled?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Brands */
export type Brands_Pk_Columns_Input = {
  wallet_address: Scalars['String'];
};

/** columns and relationships of "Brands_private" */
export type Brands_Private = {
  __typename?: 'Brands_private';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  physical_address?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** aggregated selection of "Brands_private" */
export type Brands_Private_Aggregate = {
  __typename?: 'Brands_private_aggregate';
  aggregate?: Maybe<Brands_Private_Aggregate_Fields>;
  nodes: Array<Brands_Private>;
};

/** aggregate fields of "Brands_private" */
export type Brands_Private_Aggregate_Fields = {
  __typename?: 'Brands_private_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Brands_Private_Max_Fields>;
  min?: Maybe<Brands_Private_Min_Fields>;
};


/** aggregate fields of "Brands_private" */
export type Brands_Private_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brands_Private_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Brands_private". All fields are combined with a logical 'AND'. */
export type Brands_Private_Bool_Exp = {
  _and?: InputMaybe<Array<Brands_Private_Bool_Exp>>;
  _not?: InputMaybe<Brands_Private_Bool_Exp>;
  _or?: InputMaybe<Array<Brands_Private_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  physical_address?: InputMaybe<String_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "Brands_private" */
export type Brands_Private_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  physical_address?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Brands_Private_Max_Fields = {
  __typename?: 'Brands_private_max_fields';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  physical_address?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Brands_Private_Min_Fields = {
  __typename?: 'Brands_private_min_fields';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  physical_address?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Brands_private" */
export type Brands_Private_Mutation_Response = {
  __typename?: 'Brands_private_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Brands_Private>;
};

/** input type for inserting object relation for remote table "Brands_private" */
export type Brands_Private_Obj_Rel_Insert_Input = {
  data: Brands_Private_Insert_Input;
};

/** Ordering options when selecting data from "Brands_private". */
export type Brands_Private_Order_By = {
  email?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  physical_address?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** select columns of table "Brands_private" */
export enum Brands_Private_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhysicalAddress = 'physical_address',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** input type for updating data in table "Brands_private" */
export type Brands_Private_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  physical_address?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Brands_private" */
export type Brands_Private_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brands_Private_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brands_Private_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  physical_address?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

export type Brands_Private_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brands_Private_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brands_Private_Bool_Exp;
};

/** select columns of table "Brands" */
export enum Brands_Select_Column {
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhysicalAddress = 'physical_address',
  /** column name */
  PositionAtCompany = 'position_at_company',
  /** column name */
  RoyaltyOppEnabled = 'royalty_opp_enabled',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username',
  /** column name */
  WalletAddress = 'wallet_address',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "Brands" */
export type Brands_Set_Input = {
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  physical_address?: InputMaybe<Scalars['String']>;
  position_at_company?: InputMaybe<Scalars['String']>;
  royalty_opp_enabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Brands" */
export type Brands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brands_Stream_Cursor_Value_Input = {
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  legal_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  physical_address?: InputMaybe<Scalars['String']>;
  position_at_company?: InputMaybe<Scalars['String']>;
  royalty_opp_enabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Brands" */
export enum Brands_Update_Column {
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhysicalAddress = 'physical_address',
  /** column name */
  PositionAtCompany = 'position_at_company',
  /** column name */
  RoyaltyOppEnabled = 'royalty_opp_enabled',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username',
  /** column name */
  WalletAddress = 'wallet_address',
  /** column name */
  Website = 'website'
}

export type Brands_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brands_Bool_Exp;
};

/** Junction between Collections and Deals  - so when Brands create deals they add info into this table about what kind of NFT and how much they want */
export type CollectionDeals = {
  __typename?: 'CollectionDeals';
  /** An object relationship */
  Collection: Collections;
  /** An object relationship */
  Deal: Deals;
  count: Scalars['Int'];
  deal_id: Scalars['Int'];
  id: Scalars['Int'];
  nft_contract_address: Scalars['String'];
};

/** aggregated selection of "CollectionDeals" */
export type CollectionDeals_Aggregate = {
  __typename?: 'CollectionDeals_aggregate';
  aggregate?: Maybe<CollectionDeals_Aggregate_Fields>;
  nodes: Array<CollectionDeals>;
};

export type CollectionDeals_Aggregate_Bool_Exp = {
  count?: InputMaybe<CollectionDeals_Aggregate_Bool_Exp_Count>;
};

export type CollectionDeals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CollectionDeals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "CollectionDeals" */
export type CollectionDeals_Aggregate_Fields = {
  __typename?: 'CollectionDeals_aggregate_fields';
  avg?: Maybe<CollectionDeals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CollectionDeals_Max_Fields>;
  min?: Maybe<CollectionDeals_Min_Fields>;
  stddev?: Maybe<CollectionDeals_Stddev_Fields>;
  stddev_pop?: Maybe<CollectionDeals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CollectionDeals_Stddev_Samp_Fields>;
  sum?: Maybe<CollectionDeals_Sum_Fields>;
  var_pop?: Maybe<CollectionDeals_Var_Pop_Fields>;
  var_samp?: Maybe<CollectionDeals_Var_Samp_Fields>;
  variance?: Maybe<CollectionDeals_Variance_Fields>;
};


/** aggregate fields of "CollectionDeals" */
export type CollectionDeals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "CollectionDeals" */
export type CollectionDeals_Aggregate_Order_By = {
  avg?: InputMaybe<CollectionDeals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CollectionDeals_Max_Order_By>;
  min?: InputMaybe<CollectionDeals_Min_Order_By>;
  stddev?: InputMaybe<CollectionDeals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CollectionDeals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CollectionDeals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CollectionDeals_Sum_Order_By>;
  var_pop?: InputMaybe<CollectionDeals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CollectionDeals_Var_Samp_Order_By>;
  variance?: InputMaybe<CollectionDeals_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "CollectionDeals" */
export type CollectionDeals_Arr_Rel_Insert_Input = {
  data: Array<CollectionDeals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CollectionDeals_On_Conflict>;
};

/** aggregate avg on columns */
export type CollectionDeals_Avg_Fields = {
  __typename?: 'CollectionDeals_avg_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "CollectionDeals" */
export type CollectionDeals_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "CollectionDeals". All fields are combined with a logical 'AND'. */
export type CollectionDeals_Bool_Exp = {
  Collection?: InputMaybe<Collections_Bool_Exp>;
  Deal?: InputMaybe<Deals_Bool_Exp>;
  _and?: InputMaybe<Array<CollectionDeals_Bool_Exp>>;
  _not?: InputMaybe<CollectionDeals_Bool_Exp>;
  _or?: InputMaybe<Array<CollectionDeals_Bool_Exp>>;
  count?: InputMaybe<Int_Comparison_Exp>;
  deal_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nft_contract_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "CollectionDeals" */
export enum CollectionDeals_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollectionDealsPkey = 'CollectionDeals_pkey',
  /** unique or primary key constraint on columns "nft_contract_address", "deal_id" */
  UniqueCollectiondeal = 'unique_collectiondeal'
}

/** input type for incrementing numeric columns in table "CollectionDeals" */
export type CollectionDeals_Inc_Input = {
  count?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "CollectionDeals" */
export type CollectionDeals_Insert_Input = {
  Collection?: InputMaybe<Collections_Obj_Rel_Insert_Input>;
  Deal?: InputMaybe<Deals_Obj_Rel_Insert_Input>;
  count?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CollectionDeals_Max_Fields = {
  __typename?: 'CollectionDeals_max_fields';
  count?: Maybe<Scalars['Int']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nft_contract_address?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "CollectionDeals" */
export type CollectionDeals_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CollectionDeals_Min_Fields = {
  __typename?: 'CollectionDeals_min_fields';
  count?: Maybe<Scalars['Int']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nft_contract_address?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "CollectionDeals" */
export type CollectionDeals_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "CollectionDeals" */
export type CollectionDeals_Mutation_Response = {
  __typename?: 'CollectionDeals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CollectionDeals>;
};

/** on_conflict condition type for table "CollectionDeals" */
export type CollectionDeals_On_Conflict = {
  constraint: CollectionDeals_Constraint;
  update_columns?: Array<CollectionDeals_Update_Column>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};

/** Ordering options when selecting data from "CollectionDeals". */
export type CollectionDeals_Order_By = {
  Collection?: InputMaybe<Collections_Order_By>;
  Deal?: InputMaybe<Deals_Order_By>;
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: CollectionDeals */
export type CollectionDeals_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "CollectionDeals" */
export enum CollectionDeals_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  DealId = 'deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  NftContractAddress = 'nft_contract_address'
}

/** input type for updating data in table "CollectionDeals" */
export type CollectionDeals_Set_Input = {
  count?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CollectionDeals_Stddev_Fields = {
  __typename?: 'CollectionDeals_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "CollectionDeals" */
export type CollectionDeals_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CollectionDeals_Stddev_Pop_Fields = {
  __typename?: 'CollectionDeals_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "CollectionDeals" */
export type CollectionDeals_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CollectionDeals_Stddev_Samp_Fields = {
  __typename?: 'CollectionDeals_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "CollectionDeals" */
export type CollectionDeals_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "CollectionDeals" */
export type CollectionDeals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CollectionDeals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CollectionDeals_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['Int']>;
  deal_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CollectionDeals_Sum_Fields = {
  __typename?: 'CollectionDeals_sum_fields';
  count?: Maybe<Scalars['Int']>;
  deal_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "CollectionDeals" */
export type CollectionDeals_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "CollectionDeals" */
export enum CollectionDeals_Update_Column {
  /** column name */
  Count = 'count',
  /** column name */
  DealId = 'deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  NftContractAddress = 'nft_contract_address'
}

export type CollectionDeals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CollectionDeals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CollectionDeals_Set_Input>;
  /** filter the rows which have to be updated */
  where: CollectionDeals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CollectionDeals_Var_Pop_Fields = {
  __typename?: 'CollectionDeals_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "CollectionDeals" */
export type CollectionDeals_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CollectionDeals_Var_Samp_Fields = {
  __typename?: 'CollectionDeals_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "CollectionDeals" */
export type CollectionDeals_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CollectionDeals_Variance_Fields = {
  __typename?: 'CollectionDeals_variance_fields';
  count?: Maybe<Scalars['Float']>;
  deal_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "CollectionDeals" */
export type CollectionDeals_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "Collections" */
export type Collections = {
  __typename?: 'Collections';
  /** An array relationship */
  Bids: Array<Bids>;
  /** An aggregate relationship */
  Bids_aggregate: Bids_Aggregate;
  /** An array relationship */
  CollectionDeals: Array<CollectionDeals>;
  /** An aggregate relationship */
  CollectionDeals_aggregate: CollectionDeals_Aggregate;
  created_at: Scalars['timestamptz'];
  deal_needs_approval?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  nft_contract_address: Scalars['String'];
  priority: Scalars['priority_enum'];
  rights_agreement?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Collections" */
export type CollectionsBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** columns and relationships of "Collections" */
export type CollectionsBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** columns and relationships of "Collections" */
export type CollectionsCollectionDealsArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


/** columns and relationships of "Collections" */
export type CollectionsCollectionDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};

/** aggregated selection of "Collections" */
export type Collections_Aggregate = {
  __typename?: 'Collections_aggregate';
  aggregate?: Maybe<Collections_Aggregate_Fields>;
  nodes: Array<Collections>;
};

/** aggregate fields of "Collections" */
export type Collections_Aggregate_Fields = {
  __typename?: 'Collections_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Collections_Max_Fields>;
  min?: Maybe<Collections_Min_Fields>;
};


/** aggregate fields of "Collections" */
export type Collections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Collections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Collections". All fields are combined with a logical 'AND'. */
export type Collections_Bool_Exp = {
  Bids?: InputMaybe<Bids_Bool_Exp>;
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Bool_Exp>;
  CollectionDeals?: InputMaybe<CollectionDeals_Bool_Exp>;
  CollectionDeals_aggregate?: InputMaybe<CollectionDeals_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Collections_Bool_Exp>>;
  _not?: InputMaybe<Collections_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deal_needs_approval?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nft_contract_address?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Priority_Enum_Comparison_Exp>;
  rights_agreement?: InputMaybe<String_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Collections" */
export enum Collections_Constraint {
  /** unique or primary key constraint on columns "nft_contract_address" */
  CollectionsPkey = 'Collections_pkey'
}

/** input type for inserting data into table "Collections" */
export type Collections_Insert_Input = {
  Bids?: InputMaybe<Bids_Arr_Rel_Insert_Input>;
  CollectionDeals?: InputMaybe<CollectionDeals_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deal_needs_approval?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['priority_enum']>;
  rights_agreement?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Collections_Max_Fields = {
  __typename?: 'Collections_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['priority_enum']>;
  rights_agreement?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Collections_Min_Fields = {
  __typename?: 'Collections_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nft_contract_address?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['priority_enum']>;
  rights_agreement?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Collections" */
export type Collections_Mutation_Response = {
  __typename?: 'Collections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Collections>;
};

/** input type for inserting object relation for remote table "Collections" */
export type Collections_Obj_Rel_Insert_Input = {
  data: Collections_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Collections_On_Conflict>;
};

/** on_conflict condition type for table "Collections" */
export type Collections_On_Conflict = {
  constraint: Collections_Constraint;
  update_columns?: Array<Collections_Update_Column>;
  where?: InputMaybe<Collections_Bool_Exp>;
};

/** Ordering options when selecting data from "Collections". */
export type Collections_Order_By = {
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Order_By>;
  CollectionDeals_aggregate?: InputMaybe<CollectionDeals_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deal_needs_approval?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nft_contract_address?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  rights_agreement?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Collections */
export type Collections_Pk_Columns_Input = {
  nft_contract_address: Scalars['String'];
};

/** select columns of table "Collections" */
export enum Collections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DealNeedsApproval = 'deal_needs_approval',
  /** column name */
  Description = 'description',
  /** column name */
  Image = 'image',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  Priority = 'priority',
  /** column name */
  RightsAgreement = 'rights_agreement',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "Collections" */
export type Collections_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deal_needs_approval?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['priority_enum']>;
  rights_agreement?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Collections" */
export type Collections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deal_needs_approval?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nft_contract_address?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['priority_enum']>;
  rights_agreement?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  website?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Collections" */
export enum Collections_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DealNeedsApproval = 'deal_needs_approval',
  /** column name */
  Description = 'description',
  /** column name */
  Image = 'image',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  NftContractAddress = 'nft_contract_address',
  /** column name */
  Priority = 'priority',
  /** column name */
  RightsAgreement = 'rights_agreement',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

export type Collections_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Collections_Bool_Exp;
};

/** Enum table for managing deal status */
export type DealStatus = {
  __typename?: 'DealStatus';
  /** An array relationship */
  Deals: Array<Deals>;
  /** An aggregate relationship */
  Deals_aggregate: Deals_Aggregate;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


/** Enum table for managing deal status */
export type DealStatusDealsArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


/** Enum table for managing deal status */
export type DealStatusDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};

/** aggregated selection of "DealStatus" */
export type DealStatus_Aggregate = {
  __typename?: 'DealStatus_aggregate';
  aggregate?: Maybe<DealStatus_Aggregate_Fields>;
  nodes: Array<DealStatus>;
};

/** aggregate fields of "DealStatus" */
export type DealStatus_Aggregate_Fields = {
  __typename?: 'DealStatus_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DealStatus_Max_Fields>;
  min?: Maybe<DealStatus_Min_Fields>;
};


/** aggregate fields of "DealStatus" */
export type DealStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DealStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "DealStatus". All fields are combined with a logical 'AND'. */
export type DealStatus_Bool_Exp = {
  Deals?: InputMaybe<Deals_Bool_Exp>;
  Deals_aggregate?: InputMaybe<Deals_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<DealStatus_Bool_Exp>>;
  _not?: InputMaybe<DealStatus_Bool_Exp>;
  _or?: InputMaybe<Array<DealStatus_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "DealStatus" */
export enum DealStatus_Constraint {
  /** unique or primary key constraint on columns "name" */
  DealStatusPkey = 'DealStatus_pkey'
}

export enum DealStatus_Enum {
  Completed = 'COMPLETED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

/** Boolean expression to compare columns of type "DealStatus_enum". All fields are combined with logical 'AND'. */
export type DealStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<DealStatus_Enum>;
  _in?: InputMaybe<Array<DealStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<DealStatus_Enum>;
  _nin?: InputMaybe<Array<DealStatus_Enum>>;
};

/** input type for inserting data into table "DealStatus" */
export type DealStatus_Insert_Input = {
  Deals?: InputMaybe<Deals_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DealStatus_Max_Fields = {
  __typename?: 'DealStatus_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DealStatus_Min_Fields = {
  __typename?: 'DealStatus_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "DealStatus" */
export type DealStatus_Mutation_Response = {
  __typename?: 'DealStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DealStatus>;
};

/** input type for inserting object relation for remote table "DealStatus" */
export type DealStatus_Obj_Rel_Insert_Input = {
  data: DealStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DealStatus_On_Conflict>;
};

/** on_conflict condition type for table "DealStatus" */
export type DealStatus_On_Conflict = {
  constraint: DealStatus_Constraint;
  update_columns?: Array<DealStatus_Update_Column>;
  where?: InputMaybe<DealStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "DealStatus". */
export type DealStatus_Order_By = {
  Deals_aggregate?: InputMaybe<Deals_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: DealStatus */
export type DealStatus_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "DealStatus" */
export enum DealStatus_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "DealStatus" */
export type DealStatus_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "DealStatus" */
export type DealStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DealStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DealStatus_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "DealStatus" */
export enum DealStatus_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type DealStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DealStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: DealStatus_Bool_Exp;
};

/** columns and relationships of "Deals" */
export type Deals = {
  __typename?: 'Deals';
  /** An array relationship */
  Bids: Array<Bids>;
  /** An aggregate relationship */
  Bids_aggregate: Bids_Aggregate;
  /** An object relationship */
  Brand: Brands;
  /** An array relationship */
  CollectionDeals: Array<CollectionDeals>;
  /** An aggregate relationship */
  CollectionDeals_aggregate: CollectionDeals_Aggregate;
  /** An object relationship */
  DealStatus: DealStatus;
  /** An object relationship */
  PaymentCurrency: PaymentCurrency;
  bidding_expiration: Scalars['timestamptz'];
  bonus_config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  custom_terms?: Maybe<Scalars['json']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_featured: Scalars['Boolean'];
  license_expiration: Scalars['timestamptz'];
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  payment_currency: PaymentCurrency_Enum;
  royalty_percentage?: Maybe<Scalars['numeric']>;
  status: DealStatus_Enum;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  wallet_address: Scalars['String'];
};


/** columns and relationships of "Deals" */
export type DealsBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** columns and relationships of "Deals" */
export type DealsBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** columns and relationships of "Deals" */
export type DealsCollectionDealsArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


/** columns and relationships of "Deals" */
export type DealsCollectionDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


/** columns and relationships of "Deals" */
export type DealsBonus_ConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "Deals" */
export type DealsCustom_TermsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "Deals" */
export type Deals_Aggregate = {
  __typename?: 'Deals_aggregate';
  aggregate?: Maybe<Deals_Aggregate_Fields>;
  nodes: Array<Deals>;
};

export type Deals_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Deals_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Deals_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Deals_Aggregate_Bool_Exp_Count>;
};

export type Deals_Aggregate_Bool_Exp_Bool_And = {
  arguments: Deals_Select_Column_Deals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Deals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Deals_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Deals_Select_Column_Deals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Deals_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Deals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Deals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Deals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Deals" */
export type Deals_Aggregate_Fields = {
  __typename?: 'Deals_aggregate_fields';
  avg?: Maybe<Deals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Deals_Max_Fields>;
  min?: Maybe<Deals_Min_Fields>;
  stddev?: Maybe<Deals_Stddev_Fields>;
  stddev_pop?: Maybe<Deals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Deals_Stddev_Samp_Fields>;
  sum?: Maybe<Deals_Sum_Fields>;
  var_pop?: Maybe<Deals_Var_Pop_Fields>;
  var_samp?: Maybe<Deals_Var_Samp_Fields>;
  variance?: Maybe<Deals_Variance_Fields>;
};


/** aggregate fields of "Deals" */
export type Deals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Deals" */
export type Deals_Aggregate_Order_By = {
  avg?: InputMaybe<Deals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Deals_Max_Order_By>;
  min?: InputMaybe<Deals_Min_Order_By>;
  stddev?: InputMaybe<Deals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Deals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Deals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Deals_Sum_Order_By>;
  var_pop?: InputMaybe<Deals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Deals_Var_Samp_Order_By>;
  variance?: InputMaybe<Deals_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Deals_Append_Input = {
  bonus_config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "Deals" */
export type Deals_Arr_Rel_Insert_Input = {
  data: Array<Deals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Deals_On_Conflict>;
};

/** aggregate avg on columns */
export type Deals_Avg_Fields = {
  __typename?: 'Deals_avg_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Deals" */
export type Deals_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Deals". All fields are combined with a logical 'AND'. */
export type Deals_Bool_Exp = {
  Bids?: InputMaybe<Bids_Bool_Exp>;
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Bool_Exp>;
  Brand?: InputMaybe<Brands_Bool_Exp>;
  CollectionDeals?: InputMaybe<CollectionDeals_Bool_Exp>;
  CollectionDeals_aggregate?: InputMaybe<CollectionDeals_Aggregate_Bool_Exp>;
  DealStatus?: InputMaybe<DealStatus_Bool_Exp>;
  PaymentCurrency?: InputMaybe<PaymentCurrency_Bool_Exp>;
  _and?: InputMaybe<Array<Deals_Bool_Exp>>;
  _not?: InputMaybe<Deals_Bool_Exp>;
  _or?: InputMaybe<Array<Deals_Bool_Exp>>;
  bidding_expiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  bonus_config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_terms?: InputMaybe<Json_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_featured?: InputMaybe<Boolean_Comparison_Exp>;
  license_expiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  max_budget?: InputMaybe<String_Comparison_Exp>;
  min_budget?: InputMaybe<String_Comparison_Exp>;
  payment_currency?: InputMaybe<PaymentCurrency_Enum_Comparison_Exp>;
  royalty_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<DealStatus_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Deals" */
export enum Deals_Constraint {
  /** unique or primary key constraint on columns "id" */
  DealsPkey = 'Deals_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Deals_Delete_At_Path_Input = {
  bonus_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Deals_Delete_Elem_Input = {
  bonus_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Deals_Delete_Key_Input = {
  bonus_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "Deals" */
export type Deals_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  royalty_percentage?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "Deals" */
export type Deals_Insert_Input = {
  Bids?: InputMaybe<Bids_Arr_Rel_Insert_Input>;
  Brand?: InputMaybe<Brands_Obj_Rel_Insert_Input>;
  CollectionDeals?: InputMaybe<CollectionDeals_Arr_Rel_Insert_Input>;
  DealStatus?: InputMaybe<DealStatus_Obj_Rel_Insert_Input>;
  PaymentCurrency?: InputMaybe<PaymentCurrency_Obj_Rel_Insert_Input>;
  bidding_expiration?: InputMaybe<Scalars['timestamptz']>;
  bonus_config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_terms?: InputMaybe<Scalars['json']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  license_expiration?: InputMaybe<Scalars['timestamptz']>;
  max_budget?: InputMaybe<Scalars['String']>;
  min_budget?: InputMaybe<Scalars['String']>;
  payment_currency?: InputMaybe<PaymentCurrency_Enum>;
  royalty_percentage?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<DealStatus_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Deals_Max_Fields = {
  __typename?: 'Deals_max_fields';
  bidding_expiration?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  license_expiration?: Maybe<Scalars['timestamptz']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  royalty_percentage?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Deals" */
export type Deals_Max_Order_By = {
  bidding_expiration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_expiration?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Deals_Min_Fields = {
  __typename?: 'Deals_min_fields';
  bidding_expiration?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  license_expiration?: Maybe<Scalars['timestamptz']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  royalty_percentage?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Deals" */
export type Deals_Min_Order_By = {
  bidding_expiration?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_expiration?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Deals" */
export type Deals_Mutation_Response = {
  __typename?: 'Deals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Deals>;
};

/** input type for inserting object relation for remote table "Deals" */
export type Deals_Obj_Rel_Insert_Input = {
  data: Deals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Deals_On_Conflict>;
};

/** on_conflict condition type for table "Deals" */
export type Deals_On_Conflict = {
  constraint: Deals_Constraint;
  update_columns?: Array<Deals_Update_Column>;
  where?: InputMaybe<Deals_Bool_Exp>;
};

/** Ordering options when selecting data from "Deals". */
export type Deals_Order_By = {
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Order_By>;
  Brand?: InputMaybe<Brands_Order_By>;
  CollectionDeals_aggregate?: InputMaybe<CollectionDeals_Aggregate_Order_By>;
  DealStatus?: InputMaybe<DealStatus_Order_By>;
  PaymentCurrency?: InputMaybe<PaymentCurrency_Order_By>;
  bidding_expiration?: InputMaybe<Order_By>;
  bonus_config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_terms?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_featured?: InputMaybe<Order_By>;
  license_expiration?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  payment_currency?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Deals */
export type Deals_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Deals_Prepend_Input = {
  bonus_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "Deals" */
export enum Deals_Select_Column {
  /** column name */
  BiddingExpiration = 'bidding_expiration',
  /** column name */
  BonusConfig = 'bonus_config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomTerms = 'custom_terms',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsFeatured = 'is_featured',
  /** column name */
  LicenseExpiration = 'license_expiration',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  PaymentCurrency = 'payment_currency',
  /** column name */
  RoyaltyPercentage = 'royalty_percentage',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** select "Deals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Deals" */
export enum Deals_Select_Column_Deals_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsFeatured = 'is_featured'
}

/** select "Deals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Deals" */
export enum Deals_Select_Column_Deals_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsFeatured = 'is_featured'
}

/** input type for updating data in table "Deals" */
export type Deals_Set_Input = {
  bidding_expiration?: InputMaybe<Scalars['timestamptz']>;
  bonus_config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_terms?: InputMaybe<Scalars['json']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  license_expiration?: InputMaybe<Scalars['timestamptz']>;
  max_budget?: InputMaybe<Scalars['String']>;
  min_budget?: InputMaybe<Scalars['String']>;
  payment_currency?: InputMaybe<PaymentCurrency_Enum>;
  royalty_percentage?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<DealStatus_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Deals_Stddev_Fields = {
  __typename?: 'Deals_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Deals" */
export type Deals_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Deals_Stddev_Pop_Fields = {
  __typename?: 'Deals_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Deals" */
export type Deals_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Deals_Stddev_Samp_Fields = {
  __typename?: 'Deals_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Deals" */
export type Deals_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Deals" */
export type Deals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deals_Stream_Cursor_Value_Input = {
  bidding_expiration?: InputMaybe<Scalars['timestamptz']>;
  bonus_config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_terms?: InputMaybe<Scalars['json']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  license_expiration?: InputMaybe<Scalars['timestamptz']>;
  max_budget?: InputMaybe<Scalars['String']>;
  min_budget?: InputMaybe<Scalars['String']>;
  payment_currency?: InputMaybe<PaymentCurrency_Enum>;
  royalty_percentage?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<DealStatus_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Deals_Sum_Fields = {
  __typename?: 'Deals_sum_fields';
  id?: Maybe<Scalars['Int']>;
  royalty_percentage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "Deals" */
export type Deals_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** update columns of table "Deals" */
export enum Deals_Update_Column {
  /** column name */
  BiddingExpiration = 'bidding_expiration',
  /** column name */
  BonusConfig = 'bonus_config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomTerms = 'custom_terms',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsFeatured = 'is_featured',
  /** column name */
  LicenseExpiration = 'license_expiration',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  PaymentCurrency = 'payment_currency',
  /** column name */
  RoyaltyPercentage = 'royalty_percentage',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WalletAddress = 'wallet_address'
}

export type Deals_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Deals_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Deals_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Deals_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Deals_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Deals_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Deals_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Deals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Deals_Var_Pop_Fields = {
  __typename?: 'Deals_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Deals" */
export type Deals_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Deals_Var_Samp_Fields = {
  __typename?: 'Deals_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Deals" */
export type Deals_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Deals_Variance_Fields = {
  __typename?: 'Deals_variance_fields';
  id?: Maybe<Scalars['Float']>;
  royalty_percentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Deals" */
export type Deals_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  royalty_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Enum table for payment currency */
export type PaymentCurrency = {
  __typename?: 'PaymentCurrency';
  /** An array relationship */
  Deals: Array<Deals>;
  /** An aggregate relationship */
  Deals_aggregate: Deals_Aggregate;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


/** Enum table for payment currency */
export type PaymentCurrencyDealsArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


/** Enum table for payment currency */
export type PaymentCurrencyDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};

/** aggregated selection of "PaymentCurrency" */
export type PaymentCurrency_Aggregate = {
  __typename?: 'PaymentCurrency_aggregate';
  aggregate?: Maybe<PaymentCurrency_Aggregate_Fields>;
  nodes: Array<PaymentCurrency>;
};

/** aggregate fields of "PaymentCurrency" */
export type PaymentCurrency_Aggregate_Fields = {
  __typename?: 'PaymentCurrency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PaymentCurrency_Max_Fields>;
  min?: Maybe<PaymentCurrency_Min_Fields>;
};


/** aggregate fields of "PaymentCurrency" */
export type PaymentCurrency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentCurrency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "PaymentCurrency". All fields are combined with a logical 'AND'. */
export type PaymentCurrency_Bool_Exp = {
  Deals?: InputMaybe<Deals_Bool_Exp>;
  Deals_aggregate?: InputMaybe<Deals_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<PaymentCurrency_Bool_Exp>>;
  _not?: InputMaybe<PaymentCurrency_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentCurrency_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "PaymentCurrency" */
export enum PaymentCurrency_Constraint {
  /** unique or primary key constraint on columns "name" */
  PaymentCurrencyPkey = 'PaymentCurrency_pkey'
}

export enum PaymentCurrency_Enum {
  Eth = 'ETH',
  Usdc = 'USDC'
}

/** Boolean expression to compare columns of type "PaymentCurrency_enum". All fields are combined with logical 'AND'. */
export type PaymentCurrency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<PaymentCurrency_Enum>;
  _in?: InputMaybe<Array<PaymentCurrency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentCurrency_Enum>;
  _nin?: InputMaybe<Array<PaymentCurrency_Enum>>;
};

/** input type for inserting data into table "PaymentCurrency" */
export type PaymentCurrency_Insert_Input = {
  Deals?: InputMaybe<Deals_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PaymentCurrency_Max_Fields = {
  __typename?: 'PaymentCurrency_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PaymentCurrency_Min_Fields = {
  __typename?: 'PaymentCurrency_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "PaymentCurrency" */
export type PaymentCurrency_Mutation_Response = {
  __typename?: 'PaymentCurrency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentCurrency>;
};

/** input type for inserting object relation for remote table "PaymentCurrency" */
export type PaymentCurrency_Obj_Rel_Insert_Input = {
  data: PaymentCurrency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentCurrency_On_Conflict>;
};

/** on_conflict condition type for table "PaymentCurrency" */
export type PaymentCurrency_On_Conflict = {
  constraint: PaymentCurrency_Constraint;
  update_columns?: Array<PaymentCurrency_Update_Column>;
  where?: InputMaybe<PaymentCurrency_Bool_Exp>;
};

/** Ordering options when selecting data from "PaymentCurrency". */
export type PaymentCurrency_Order_By = {
  Deals_aggregate?: InputMaybe<Deals_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PaymentCurrency */
export type PaymentCurrency_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "PaymentCurrency" */
export enum PaymentCurrency_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "PaymentCurrency" */
export type PaymentCurrency_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "PaymentCurrency" */
export type PaymentCurrency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentCurrency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentCurrency_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "PaymentCurrency" */
export enum PaymentCurrency_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type PaymentCurrency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentCurrency_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentCurrency_Bool_Exp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "Users" */
export type Users = {
  __typename?: 'Users';
  /** An array relationship */
  Bids: Array<Bids>;
  /** An aggregate relationship */
  Bids_aggregate: Bids_Aggregate;
  /** An object relationship */
  Brand?: Maybe<Brands>;
  /** An object relationship */
  UsersRole?: Maybe<UsersRole>;
  /** An object relationship */
  Users_private_info?: Maybe<Users_Private>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** adding user instagram */
  instagram?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  /** adding user name */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  /** adding role */
  role?: Maybe<UsersRole_Enum>;
  /** adding users twitter */
  twitter?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  username?: Maybe<Scalars['String']>;
  wallet_address: Scalars['String'];
};


/** columns and relationships of "Users" */
export type UsersBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


/** columns and relationships of "Users" */
export type UsersBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};

/** columns and relationships of "UsersRole" */
export type UsersRole = {
  __typename?: 'UsersRole';
  /** An array relationship */
  Users: Array<Users>;
  /** An aggregate relationship */
  Users_aggregate: Users_Aggregate;
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};


/** columns and relationships of "UsersRole" */
export type UsersRoleUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "UsersRole" */
export type UsersRoleUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "UsersRole" */
export type UsersRole_Aggregate = {
  __typename?: 'UsersRole_aggregate';
  aggregate?: Maybe<UsersRole_Aggregate_Fields>;
  nodes: Array<UsersRole>;
};

/** aggregate fields of "UsersRole" */
export type UsersRole_Aggregate_Fields = {
  __typename?: 'UsersRole_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UsersRole_Max_Fields>;
  min?: Maybe<UsersRole_Min_Fields>;
};


/** aggregate fields of "UsersRole" */
export type UsersRole_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersRole_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "UsersRole". All fields are combined with a logical 'AND'. */
export type UsersRole_Bool_Exp = {
  Users?: InputMaybe<Users_Bool_Exp>;
  Users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<UsersRole_Bool_Exp>>;
  _not?: InputMaybe<UsersRole_Bool_Exp>;
  _or?: InputMaybe<Array<UsersRole_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "UsersRole" */
export enum UsersRole_Constraint {
  /** unique or primary key constraint on columns "value" */
  UsersRolePkey = 'UsersRole_pkey'
}

export enum UsersRole_Enum {
  /** Users with the privilege to create deals */
  Brand = 'BRAND',
  /** Ordinary users */
  User = 'USER'
}

/** Boolean expression to compare columns of type "UsersRole_enum". All fields are combined with logical 'AND'. */
export type UsersRole_Enum_Comparison_Exp = {
  _eq?: InputMaybe<UsersRole_Enum>;
  _in?: InputMaybe<Array<UsersRole_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<UsersRole_Enum>;
  _nin?: InputMaybe<Array<UsersRole_Enum>>;
};

/** input type for inserting data into table "UsersRole" */
export type UsersRole_Insert_Input = {
  Users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsersRole_Max_Fields = {
  __typename?: 'UsersRole_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UsersRole_Min_Fields = {
  __typename?: 'UsersRole_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "UsersRole" */
export type UsersRole_Mutation_Response = {
  __typename?: 'UsersRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersRole>;
};

/** input type for inserting object relation for remote table "UsersRole" */
export type UsersRole_Obj_Rel_Insert_Input = {
  data: UsersRole_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersRole_On_Conflict>;
};

/** on_conflict condition type for table "UsersRole" */
export type UsersRole_On_Conflict = {
  constraint: UsersRole_Constraint;
  update_columns?: Array<UsersRole_Update_Column>;
  where?: InputMaybe<UsersRole_Bool_Exp>;
};

/** Ordering options when selecting data from "UsersRole". */
export type UsersRole_Order_By = {
  Users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: UsersRole */
export type UsersRole_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "UsersRole" */
export enum UsersRole_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "UsersRole" */
export type UsersRole_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "UsersRole" */
export type UsersRole_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersRole_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersRole_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "UsersRole" */
export enum UsersRole_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type UsersRole_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersRole_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersRole_Bool_Exp;
};

/** aggregated selection of "Users" */
export type Users_Aggregate = {
  __typename?: 'Users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Users" */
export type Users_Aggregate_Fields = {
  __typename?: 'Users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "Users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  Bids?: InputMaybe<Bids_Bool_Exp>;
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Bool_Exp>;
  Brand?: InputMaybe<Brands_Bool_Exp>;
  UsersRole?: InputMaybe<UsersRole_Bool_Exp>;
  Users_private_info?: InputMaybe<Users_Private_Bool_Exp>;
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  refresh_token?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<UsersRole_Enum_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "wallet_address" */
  UsersPkey = 'Users_pkey',
  /** unique or primary key constraint on columns "username" */
  UsersUsernameKey = 'Users_username_key',
  /** unique or primary key constraint on columns "wallet_address" */
  UsersWalletAddressKey = 'Users_wallet_address_key'
}

/** input type for inserting data into table "Users" */
export type Users_Insert_Input = {
  Bids?: InputMaybe<Bids_Arr_Rel_Insert_Input>;
  Brand?: InputMaybe<Brands_Obj_Rel_Insert_Input>;
  UsersRole?: InputMaybe<UsersRole_Obj_Rel_Insert_Input>;
  Users_private_info?: InputMaybe<Users_Private_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** adding user instagram */
  instagram?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  /** adding user name */
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  /** adding role */
  role?: InputMaybe<UsersRole_Enum>;
  /** adding users twitter */
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'Users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** adding user instagram */
  instagram?: Maybe<Scalars['String']>;
  /** adding user name */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  /** adding users twitter */
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Users" */
export type Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  /** adding user instagram */
  instagram?: InputMaybe<Order_By>;
  /** adding user name */
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  /** adding users twitter */
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'Users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** adding user instagram */
  instagram?: Maybe<Scalars['String']>;
  /** adding user name */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  /** adding users twitter */
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Users" */
export type Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  /** adding user instagram */
  instagram?: InputMaybe<Order_By>;
  /** adding user name */
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  /** adding users twitter */
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Users" */
export type Users_Mutation_Response = {
  __typename?: 'Users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "Users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "Users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "Users". */
export type Users_Order_By = {
  Bids_aggregate?: InputMaybe<Bids_Aggregate_Order_By>;
  Brand?: InputMaybe<Brands_Order_By>;
  UsersRole?: InputMaybe<UsersRole_Order_By>;
  Users_private_info?: InputMaybe<Users_Private_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Users */
export type Users_Pk_Columns_Input = {
  wallet_address: Scalars['String'];
};

/** columns and relationships of "Users_private" */
export type Users_Private = {
  __typename?: 'Users_private';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** aggregated selection of "Users_private" */
export type Users_Private_Aggregate = {
  __typename?: 'Users_private_aggregate';
  aggregate?: Maybe<Users_Private_Aggregate_Fields>;
  nodes: Array<Users_Private>;
};

/** aggregate fields of "Users_private" */
export type Users_Private_Aggregate_Fields = {
  __typename?: 'Users_private_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Private_Max_Fields>;
  min?: Maybe<Users_Private_Min_Fields>;
};


/** aggregate fields of "Users_private" */
export type Users_Private_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Private_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Users_private". All fields are combined with a logical 'AND'. */
export type Users_Private_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Private_Bool_Exp>>;
  _not?: InputMaybe<Users_Private_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Private_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  wallet_address?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "Users_private" */
export type Users_Private_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Private_Max_Fields = {
  __typename?: 'Users_private_max_fields';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Private_Min_Fields = {
  __typename?: 'Users_private_min_fields';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  wallet_address?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Users_private" */
export type Users_Private_Mutation_Response = {
  __typename?: 'Users_private_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Private>;
};

/** input type for inserting object relation for remote table "Users_private" */
export type Users_Private_Obj_Rel_Insert_Input = {
  data: Users_Private_Insert_Input;
};

/** Ordering options when selecting data from "Users_private". */
export type Users_Private_Order_By = {
  email?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  wallet_address?: InputMaybe<Order_By>;
};

/** select columns of table "Users_private" */
export enum Users_Private_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Phone = 'phone',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** input type for updating data in table "Users_private" */
export type Users_Private_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Users_private" */
export type Users_Private_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Private_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Private_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

export type Users_Private_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Private_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Private_Bool_Exp;
};

/** select columns of table "Users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  Role = 'role',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username',
  /** column name */
  WalletAddress = 'wallet_address'
}

/** select "Users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified'
}

/** select "Users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified'
}

/** input type for updating data in table "Users" */
export type Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** adding user instagram */
  instagram?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  /** adding user name */
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  /** adding role */
  role?: InputMaybe<UsersRole_Enum>;
  /** adding users twitter */
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** adding user instagram */
  instagram?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  /** adding user name */
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  /** adding role */
  role?: InputMaybe<UsersRole_Enum>;
  /** adding users twitter */
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  wallet_address?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  Role = 'role',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username',
  /** column name */
  WalletAddress = 'wallet_address'
}

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "BidStatus" */
  delete_BidStatus?: Maybe<BidStatus_Mutation_Response>;
  /** delete single row from the table: "BidStatus" */
  delete_BidStatus_by_pk?: Maybe<BidStatus>;
  /** delete data from the table: "Bids" */
  delete_Bids?: Maybe<Bids_Mutation_Response>;
  /** delete single row from the table: "Bids" */
  delete_Bids_by_pk?: Maybe<Bids>;
  /** delete data from the table: "Bids_private" */
  delete_Bids_private?: Maybe<Bids_Private_Mutation_Response>;
  /** delete data from the table: "Brands" */
  delete_Brands?: Maybe<Brands_Mutation_Response>;
  /** delete single row from the table: "Brands" */
  delete_Brands_by_pk?: Maybe<Brands>;
  /** delete data from the table: "Brands_private" */
  delete_Brands_private?: Maybe<Brands_Private_Mutation_Response>;
  /** delete data from the table: "CollectionDeals" */
  delete_CollectionDeals?: Maybe<CollectionDeals_Mutation_Response>;
  /** delete single row from the table: "CollectionDeals" */
  delete_CollectionDeals_by_pk?: Maybe<CollectionDeals>;
  /** delete data from the table: "Collections" */
  delete_Collections?: Maybe<Collections_Mutation_Response>;
  /** delete single row from the table: "Collections" */
  delete_Collections_by_pk?: Maybe<Collections>;
  /** delete data from the table: "DealStatus" */
  delete_DealStatus?: Maybe<DealStatus_Mutation_Response>;
  /** delete single row from the table: "DealStatus" */
  delete_DealStatus_by_pk?: Maybe<DealStatus>;
  /** delete data from the table: "Deals" */
  delete_Deals?: Maybe<Deals_Mutation_Response>;
  /** delete single row from the table: "Deals" */
  delete_Deals_by_pk?: Maybe<Deals>;
  /** delete data from the table: "PaymentCurrency" */
  delete_PaymentCurrency?: Maybe<PaymentCurrency_Mutation_Response>;
  /** delete single row from the table: "PaymentCurrency" */
  delete_PaymentCurrency_by_pk?: Maybe<PaymentCurrency>;
  /** delete data from the table: "Users" */
  delete_Users?: Maybe<Users_Mutation_Response>;
  /** delete data from the table: "UsersRole" */
  delete_UsersRole?: Maybe<UsersRole_Mutation_Response>;
  /** delete single row from the table: "UsersRole" */
  delete_UsersRole_by_pk?: Maybe<UsersRole>;
  /** delete single row from the table: "Users" */
  delete_Users_by_pk?: Maybe<Users>;
  /** delete data from the table: "Users_private" */
  delete_Users_private?: Maybe<Users_Private_Mutation_Response>;
  /** insert data into the table: "BidStatus" */
  insert_BidStatus?: Maybe<BidStatus_Mutation_Response>;
  /** insert a single row into the table: "BidStatus" */
  insert_BidStatus_one?: Maybe<BidStatus>;
  /** insert data into the table: "Bids" */
  insert_Bids?: Maybe<Bids_Mutation_Response>;
  /** insert a single row into the table: "Bids" */
  insert_Bids_one?: Maybe<Bids>;
  /** insert data into the table: "Bids_private" */
  insert_Bids_private?: Maybe<Bids_Private_Mutation_Response>;
  /** insert a single row into the table: "Bids_private" */
  insert_Bids_private_one?: Maybe<Bids_Private>;
  /** insert data into the table: "Brands" */
  insert_Brands?: Maybe<Brands_Mutation_Response>;
  /** insert a single row into the table: "Brands" */
  insert_Brands_one?: Maybe<Brands>;
  /** insert data into the table: "Brands_private" */
  insert_Brands_private?: Maybe<Brands_Private_Mutation_Response>;
  /** insert a single row into the table: "Brands_private" */
  insert_Brands_private_one?: Maybe<Brands_Private>;
  /** insert data into the table: "CollectionDeals" */
  insert_CollectionDeals?: Maybe<CollectionDeals_Mutation_Response>;
  /** insert a single row into the table: "CollectionDeals" */
  insert_CollectionDeals_one?: Maybe<CollectionDeals>;
  /** insert data into the table: "Collections" */
  insert_Collections?: Maybe<Collections_Mutation_Response>;
  /** insert a single row into the table: "Collections" */
  insert_Collections_one?: Maybe<Collections>;
  /** insert data into the table: "DealStatus" */
  insert_DealStatus?: Maybe<DealStatus_Mutation_Response>;
  /** insert a single row into the table: "DealStatus" */
  insert_DealStatus_one?: Maybe<DealStatus>;
  /** insert data into the table: "Deals" */
  insert_Deals?: Maybe<Deals_Mutation_Response>;
  /** insert a single row into the table: "Deals" */
  insert_Deals_one?: Maybe<Deals>;
  /** insert data into the table: "PaymentCurrency" */
  insert_PaymentCurrency?: Maybe<PaymentCurrency_Mutation_Response>;
  /** insert a single row into the table: "PaymentCurrency" */
  insert_PaymentCurrency_one?: Maybe<PaymentCurrency>;
  /** insert data into the table: "Users" */
  insert_Users?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "UsersRole" */
  insert_UsersRole?: Maybe<UsersRole_Mutation_Response>;
  /** insert a single row into the table: "UsersRole" */
  insert_UsersRole_one?: Maybe<UsersRole>;
  /** insert a single row into the table: "Users" */
  insert_Users_one?: Maybe<Users>;
  /** insert data into the table: "Users_private" */
  insert_Users_private?: Maybe<Users_Private_Mutation_Response>;
  /** insert a single row into the table: "Users_private" */
  insert_Users_private_one?: Maybe<Users_Private>;
  /** update data of the table: "BidStatus" */
  update_BidStatus?: Maybe<BidStatus_Mutation_Response>;
  /** update single row of the table: "BidStatus" */
  update_BidStatus_by_pk?: Maybe<BidStatus>;
  /** update multiples rows of table: "BidStatus" */
  update_BidStatus_many?: Maybe<Array<Maybe<BidStatus_Mutation_Response>>>;
  /** update data of the table: "Bids" */
  update_Bids?: Maybe<Bids_Mutation_Response>;
  /** update single row of the table: "Bids" */
  update_Bids_by_pk?: Maybe<Bids>;
  /** update multiples rows of table: "Bids" */
  update_Bids_many?: Maybe<Array<Maybe<Bids_Mutation_Response>>>;
  /** update data of the table: "Bids_private" */
  update_Bids_private?: Maybe<Bids_Private_Mutation_Response>;
  /** update multiples rows of table: "Bids_private" */
  update_Bids_private_many?: Maybe<Array<Maybe<Bids_Private_Mutation_Response>>>;
  /** update data of the table: "Brands" */
  update_Brands?: Maybe<Brands_Mutation_Response>;
  /** update single row of the table: "Brands" */
  update_Brands_by_pk?: Maybe<Brands>;
  /** update multiples rows of table: "Brands" */
  update_Brands_many?: Maybe<Array<Maybe<Brands_Mutation_Response>>>;
  /** update data of the table: "Brands_private" */
  update_Brands_private?: Maybe<Brands_Private_Mutation_Response>;
  /** update multiples rows of table: "Brands_private" */
  update_Brands_private_many?: Maybe<Array<Maybe<Brands_Private_Mutation_Response>>>;
  /** update data of the table: "CollectionDeals" */
  update_CollectionDeals?: Maybe<CollectionDeals_Mutation_Response>;
  /** update single row of the table: "CollectionDeals" */
  update_CollectionDeals_by_pk?: Maybe<CollectionDeals>;
  /** update multiples rows of table: "CollectionDeals" */
  update_CollectionDeals_many?: Maybe<Array<Maybe<CollectionDeals_Mutation_Response>>>;
  /** update data of the table: "Collections" */
  update_Collections?: Maybe<Collections_Mutation_Response>;
  /** update single row of the table: "Collections" */
  update_Collections_by_pk?: Maybe<Collections>;
  /** update multiples rows of table: "Collections" */
  update_Collections_many?: Maybe<Array<Maybe<Collections_Mutation_Response>>>;
  /** update data of the table: "DealStatus" */
  update_DealStatus?: Maybe<DealStatus_Mutation_Response>;
  /** update single row of the table: "DealStatus" */
  update_DealStatus_by_pk?: Maybe<DealStatus>;
  /** update multiples rows of table: "DealStatus" */
  update_DealStatus_many?: Maybe<Array<Maybe<DealStatus_Mutation_Response>>>;
  /** update data of the table: "Deals" */
  update_Deals?: Maybe<Deals_Mutation_Response>;
  /** update single row of the table: "Deals" */
  update_Deals_by_pk?: Maybe<Deals>;
  /** update multiples rows of table: "Deals" */
  update_Deals_many?: Maybe<Array<Maybe<Deals_Mutation_Response>>>;
  /** update data of the table: "PaymentCurrency" */
  update_PaymentCurrency?: Maybe<PaymentCurrency_Mutation_Response>;
  /** update single row of the table: "PaymentCurrency" */
  update_PaymentCurrency_by_pk?: Maybe<PaymentCurrency>;
  /** update multiples rows of table: "PaymentCurrency" */
  update_PaymentCurrency_many?: Maybe<Array<Maybe<PaymentCurrency_Mutation_Response>>>;
  /** update data of the table: "Users" */
  update_Users?: Maybe<Users_Mutation_Response>;
  /** update data of the table: "UsersRole" */
  update_UsersRole?: Maybe<UsersRole_Mutation_Response>;
  /** update single row of the table: "UsersRole" */
  update_UsersRole_by_pk?: Maybe<UsersRole>;
  /** update multiples rows of table: "UsersRole" */
  update_UsersRole_many?: Maybe<Array<Maybe<UsersRole_Mutation_Response>>>;
  /** update single row of the table: "Users" */
  update_Users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "Users" */
  update_Users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "Users_private" */
  update_Users_private?: Maybe<Users_Private_Mutation_Response>;
  /** update multiples rows of table: "Users_private" */
  update_Users_private_many?: Maybe<Array<Maybe<Users_Private_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_BidStatusArgs = {
  where: BidStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BidStatus_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_BidsArgs = {
  where: Bids_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bids_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Bids_PrivateArgs = {
  where: Bids_Private_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BrandsArgs = {
  where: Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brands_By_PkArgs = {
  wallet_address: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Brands_PrivateArgs = {
  where: Brands_Private_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CollectionDealsArgs = {
  where: CollectionDeals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CollectionDeals_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CollectionsArgs = {
  where: Collections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Collections_By_PkArgs = {
  nft_contract_address: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_DealStatusArgs = {
  where: DealStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DealStatus_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_DealsArgs = {
  where: Deals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Deals_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentCurrencyArgs = {
  where: PaymentCurrency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PaymentCurrency_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UsersRoleArgs = {
  where: UsersRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UsersRole_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  wallet_address: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Users_PrivateArgs = {
  where: Users_Private_Bool_Exp;
};


/** mutation root */
export type Mutation_RootInsert_BidStatusArgs = {
  objects: Array<BidStatus_Insert_Input>;
  on_conflict?: InputMaybe<BidStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BidStatus_OneArgs = {
  object: BidStatus_Insert_Input;
  on_conflict?: InputMaybe<BidStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BidsArgs = {
  objects: Array<Bids_Insert_Input>;
  on_conflict?: InputMaybe<Bids_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bids_OneArgs = {
  object: Bids_Insert_Input;
  on_conflict?: InputMaybe<Bids_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bids_PrivateArgs = {
  objects: Array<Bids_Private_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Bids_Private_OneArgs = {
  object: Bids_Private_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_BrandsArgs = {
  objects: Array<Brands_Insert_Input>;
  on_conflict?: InputMaybe<Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brands_OneArgs = {
  object: Brands_Insert_Input;
  on_conflict?: InputMaybe<Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brands_PrivateArgs = {
  objects: Array<Brands_Private_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Brands_Private_OneArgs = {
  object: Brands_Private_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_CollectionDealsArgs = {
  objects: Array<CollectionDeals_Insert_Input>;
  on_conflict?: InputMaybe<CollectionDeals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CollectionDeals_OneArgs = {
  object: CollectionDeals_Insert_Input;
  on_conflict?: InputMaybe<CollectionDeals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CollectionsArgs = {
  objects: Array<Collections_Insert_Input>;
  on_conflict?: InputMaybe<Collections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collections_OneArgs = {
  object: Collections_Insert_Input;
  on_conflict?: InputMaybe<Collections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DealStatusArgs = {
  objects: Array<DealStatus_Insert_Input>;
  on_conflict?: InputMaybe<DealStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DealStatus_OneArgs = {
  object: DealStatus_Insert_Input;
  on_conflict?: InputMaybe<DealStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DealsArgs = {
  objects: Array<Deals_Insert_Input>;
  on_conflict?: InputMaybe<Deals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deals_OneArgs = {
  object: Deals_Insert_Input;
  on_conflict?: InputMaybe<Deals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentCurrencyArgs = {
  objects: Array<PaymentCurrency_Insert_Input>;
  on_conflict?: InputMaybe<PaymentCurrency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentCurrency_OneArgs = {
  object: PaymentCurrency_Insert_Input;
  on_conflict?: InputMaybe<PaymentCurrency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersRoleArgs = {
  objects: Array<UsersRole_Insert_Input>;
  on_conflict?: InputMaybe<UsersRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersRole_OneArgs = {
  object: UsersRole_Insert_Input;
  on_conflict?: InputMaybe<UsersRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_PrivateArgs = {
  objects: Array<Users_Private_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Private_OneArgs = {
  object: Users_Private_Insert_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BidStatusArgs = {
  _set?: InputMaybe<BidStatus_Set_Input>;
  where: BidStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BidStatus_By_PkArgs = {
  _set?: InputMaybe<BidStatus_Set_Input>;
  pk_columns: BidStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BidStatus_ManyArgs = {
  updates: Array<BidStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BidsArgs = {
  _inc?: InputMaybe<Bids_Inc_Input>;
  _set?: InputMaybe<Bids_Set_Input>;
  where: Bids_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_By_PkArgs = {
  _inc?: InputMaybe<Bids_Inc_Input>;
  _set?: InputMaybe<Bids_Set_Input>;
  pk_columns: Bids_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_ManyArgs = {
  updates: Array<Bids_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_PrivateArgs = {
  _inc?: InputMaybe<Bids_Private_Inc_Input>;
  _set?: InputMaybe<Bids_Private_Set_Input>;
  where: Bids_Private_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bids_Private_ManyArgs = {
  updates: Array<Bids_Private_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BrandsArgs = {
  _set?: InputMaybe<Brands_Set_Input>;
  where: Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brands_By_PkArgs = {
  _set?: InputMaybe<Brands_Set_Input>;
  pk_columns: Brands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brands_ManyArgs = {
  updates: Array<Brands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brands_PrivateArgs = {
  _set?: InputMaybe<Brands_Private_Set_Input>;
  where: Brands_Private_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brands_Private_ManyArgs = {
  updates: Array<Brands_Private_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CollectionDealsArgs = {
  _inc?: InputMaybe<CollectionDeals_Inc_Input>;
  _set?: InputMaybe<CollectionDeals_Set_Input>;
  where: CollectionDeals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CollectionDeals_By_PkArgs = {
  _inc?: InputMaybe<CollectionDeals_Inc_Input>;
  _set?: InputMaybe<CollectionDeals_Set_Input>;
  pk_columns: CollectionDeals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CollectionDeals_ManyArgs = {
  updates: Array<CollectionDeals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CollectionsArgs = {
  _set?: InputMaybe<Collections_Set_Input>;
  where: Collections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Collections_By_PkArgs = {
  _set?: InputMaybe<Collections_Set_Input>;
  pk_columns: Collections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Collections_ManyArgs = {
  updates: Array<Collections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DealStatusArgs = {
  _set?: InputMaybe<DealStatus_Set_Input>;
  where: DealStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DealStatus_By_PkArgs = {
  _set?: InputMaybe<DealStatus_Set_Input>;
  pk_columns: DealStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DealStatus_ManyArgs = {
  updates: Array<DealStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DealsArgs = {
  _append?: InputMaybe<Deals_Append_Input>;
  _delete_at_path?: InputMaybe<Deals_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Deals_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Deals_Delete_Key_Input>;
  _inc?: InputMaybe<Deals_Inc_Input>;
  _prepend?: InputMaybe<Deals_Prepend_Input>;
  _set?: InputMaybe<Deals_Set_Input>;
  where: Deals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Deals_By_PkArgs = {
  _append?: InputMaybe<Deals_Append_Input>;
  _delete_at_path?: InputMaybe<Deals_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Deals_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Deals_Delete_Key_Input>;
  _inc?: InputMaybe<Deals_Inc_Input>;
  _prepend?: InputMaybe<Deals_Prepend_Input>;
  _set?: InputMaybe<Deals_Set_Input>;
  pk_columns: Deals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Deals_ManyArgs = {
  updates: Array<Deals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentCurrencyArgs = {
  _set?: InputMaybe<PaymentCurrency_Set_Input>;
  where: PaymentCurrency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentCurrency_By_PkArgs = {
  _set?: InputMaybe<PaymentCurrency_Set_Input>;
  pk_columns: PaymentCurrency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentCurrency_ManyArgs = {
  updates: Array<PaymentCurrency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsersRoleArgs = {
  _set?: InputMaybe<UsersRole_Set_Input>;
  where: UsersRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsersRole_By_PkArgs = {
  _set?: InputMaybe<UsersRole_Set_Input>;
  pk_columns: UsersRole_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersRole_ManyArgs = {
  updates: Array<UsersRole_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_PrivateArgs = {
  _set?: InputMaybe<Users_Private_Set_Input>;
  where: Users_Private_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Private_ManyArgs = {
  updates: Array<Users_Private_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Boolean expression to compare columns of type "priority_enum". All fields are combined with logical 'AND'. */
export type Priority_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['priority_enum']>;
  _gt?: InputMaybe<Scalars['priority_enum']>;
  _gte?: InputMaybe<Scalars['priority_enum']>;
  _in?: InputMaybe<Array<Scalars['priority_enum']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['priority_enum']>;
  _lte?: InputMaybe<Scalars['priority_enum']>;
  _neq?: InputMaybe<Scalars['priority_enum']>;
  _nin?: InputMaybe<Array<Scalars['priority_enum']>>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "BidStatus" */
  BidStatus: Array<BidStatus>;
  /** fetch aggregated fields from the table: "BidStatus" */
  BidStatus_aggregate: BidStatus_Aggregate;
  /** fetch data from the table: "BidStatus" using primary key columns */
  BidStatus_by_pk?: Maybe<BidStatus>;
  /** An array relationship */
  Bids: Array<Bids>;
  /** An aggregate relationship */
  Bids_aggregate: Bids_Aggregate;
  /** fetch data from the table: "Bids" using primary key columns */
  Bids_by_pk?: Maybe<Bids>;
  /** fetch data from the table: "Bids_private" */
  Bids_private: Array<Bids_Private>;
  /** fetch aggregated fields from the table: "Bids_private" */
  Bids_private_aggregate: Bids_Private_Aggregate;
  /** fetch data from the table: "Brands" */
  Brands: Array<Brands>;
  /** fetch aggregated fields from the table: "Brands" */
  Brands_aggregate: Brands_Aggregate;
  /** fetch data from the table: "Brands" using primary key columns */
  Brands_by_pk?: Maybe<Brands>;
  /** fetch data from the table: "Brands_private" */
  Brands_private: Array<Brands_Private>;
  /** fetch aggregated fields from the table: "Brands_private" */
  Brands_private_aggregate: Brands_Private_Aggregate;
  /** An array relationship */
  CollectionDeals: Array<CollectionDeals>;
  /** An aggregate relationship */
  CollectionDeals_aggregate: CollectionDeals_Aggregate;
  /** fetch data from the table: "CollectionDeals" using primary key columns */
  CollectionDeals_by_pk?: Maybe<CollectionDeals>;
  /** fetch data from the table: "Collections" */
  Collections: Array<Collections>;
  /** fetch aggregated fields from the table: "Collections" */
  Collections_aggregate: Collections_Aggregate;
  /** fetch data from the table: "Collections" using primary key columns */
  Collections_by_pk?: Maybe<Collections>;
  /** fetch data from the table: "DealStatus" */
  DealStatus: Array<DealStatus>;
  /** fetch aggregated fields from the table: "DealStatus" */
  DealStatus_aggregate: DealStatus_Aggregate;
  /** fetch data from the table: "DealStatus" using primary key columns */
  DealStatus_by_pk?: Maybe<DealStatus>;
  /** An array relationship */
  Deals: Array<Deals>;
  /** An aggregate relationship */
  Deals_aggregate: Deals_Aggregate;
  /** fetch data from the table: "Deals" using primary key columns */
  Deals_by_pk?: Maybe<Deals>;
  /** fetch data from the table: "PaymentCurrency" */
  PaymentCurrency: Array<PaymentCurrency>;
  /** fetch aggregated fields from the table: "PaymentCurrency" */
  PaymentCurrency_aggregate: PaymentCurrency_Aggregate;
  /** fetch data from the table: "PaymentCurrency" using primary key columns */
  PaymentCurrency_by_pk?: Maybe<PaymentCurrency>;
  /** An array relationship */
  Users: Array<Users>;
  /** fetch data from the table: "UsersRole" */
  UsersRole: Array<UsersRole>;
  /** fetch aggregated fields from the table: "UsersRole" */
  UsersRole_aggregate: UsersRole_Aggregate;
  /** fetch data from the table: "UsersRole" using primary key columns */
  UsersRole_by_pk?: Maybe<UsersRole>;
  /** An aggregate relationship */
  Users_aggregate: Users_Aggregate;
  /** fetch data from the table: "Users" using primary key columns */
  Users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "Users_private" */
  Users_private: Array<Users_Private>;
  /** fetch aggregated fields from the table: "Users_private" */
  Users_private_aggregate: Users_Private_Aggregate;
};


export type Query_RootBidStatusArgs = {
  distinct_on?: InputMaybe<Array<BidStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BidStatus_Order_By>>;
  where?: InputMaybe<BidStatus_Bool_Exp>;
};


export type Query_RootBidStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BidStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BidStatus_Order_By>>;
  where?: InputMaybe<BidStatus_Bool_Exp>;
};


export type Query_RootBidStatus_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Query_RootBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Query_RootBids_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBids_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Private_Order_By>>;
  where?: InputMaybe<Bids_Private_Bool_Exp>;
};


export type Query_RootBids_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Private_Order_By>>;
  where?: InputMaybe<Bids_Private_Bool_Exp>;
};


export type Query_RootBrandsArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Query_RootBrands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Query_RootBrands_By_PkArgs = {
  wallet_address: Scalars['String'];
};


export type Query_RootBrands_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Private_Order_By>>;
  where?: InputMaybe<Brands_Private_Bool_Exp>;
};


export type Query_RootBrands_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Private_Order_By>>;
  where?: InputMaybe<Brands_Private_Bool_Exp>;
};


export type Query_RootCollectionDealsArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


export type Query_RootCollectionDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


export type Query_RootCollectionDeals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Query_RootCollections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Query_RootCollections_By_PkArgs = {
  nft_contract_address: Scalars['String'];
};


export type Query_RootDealStatusArgs = {
  distinct_on?: InputMaybe<Array<DealStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealStatus_Order_By>>;
  where?: InputMaybe<DealStatus_Bool_Exp>;
};


export type Query_RootDealStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DealStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealStatus_Order_By>>;
  where?: InputMaybe<DealStatus_Bool_Exp>;
};


export type Query_RootDealStatus_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDealsArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


export type Query_RootDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


export type Query_RootDeals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPaymentCurrencyArgs = {
  distinct_on?: InputMaybe<Array<PaymentCurrency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentCurrency_Order_By>>;
  where?: InputMaybe<PaymentCurrency_Bool_Exp>;
};


export type Query_RootPaymentCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentCurrency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentCurrency_Order_By>>;
  where?: InputMaybe<PaymentCurrency_Bool_Exp>;
};


export type Query_RootPaymentCurrency_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersRoleArgs = {
  distinct_on?: InputMaybe<Array<UsersRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersRole_Order_By>>;
  where?: InputMaybe<UsersRole_Bool_Exp>;
};


export type Query_RootUsersRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersRole_Order_By>>;
  where?: InputMaybe<UsersRole_Bool_Exp>;
};


export type Query_RootUsersRole_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  wallet_address: Scalars['String'];
};


export type Query_RootUsers_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Users_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Private_Order_By>>;
  where?: InputMaybe<Users_Private_Bool_Exp>;
};


export type Query_RootUsers_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Private_Order_By>>;
  where?: InputMaybe<Users_Private_Bool_Exp>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "BidStatus" */
  BidStatus: Array<BidStatus>;
  /** fetch aggregated fields from the table: "BidStatus" */
  BidStatus_aggregate: BidStatus_Aggregate;
  /** fetch data from the table: "BidStatus" using primary key columns */
  BidStatus_by_pk?: Maybe<BidStatus>;
  /** fetch data from the table in a streaming manner: "BidStatus" */
  BidStatus_stream: Array<BidStatus>;
  /** An array relationship */
  Bids: Array<Bids>;
  /** An aggregate relationship */
  Bids_aggregate: Bids_Aggregate;
  /** fetch data from the table: "Bids" using primary key columns */
  Bids_by_pk?: Maybe<Bids>;
  /** fetch data from the table: "Bids_private" */
  Bids_private: Array<Bids_Private>;
  /** fetch aggregated fields from the table: "Bids_private" */
  Bids_private_aggregate: Bids_Private_Aggregate;
  /** fetch data from the table in a streaming manner: "Bids_private" */
  Bids_private_stream: Array<Bids_Private>;
  /** fetch data from the table in a streaming manner: "Bids" */
  Bids_stream: Array<Bids>;
  /** fetch data from the table: "Brands" */
  Brands: Array<Brands>;
  /** fetch aggregated fields from the table: "Brands" */
  Brands_aggregate: Brands_Aggregate;
  /** fetch data from the table: "Brands" using primary key columns */
  Brands_by_pk?: Maybe<Brands>;
  /** fetch data from the table: "Brands_private" */
  Brands_private: Array<Brands_Private>;
  /** fetch aggregated fields from the table: "Brands_private" */
  Brands_private_aggregate: Brands_Private_Aggregate;
  /** fetch data from the table in a streaming manner: "Brands_private" */
  Brands_private_stream: Array<Brands_Private>;
  /** fetch data from the table in a streaming manner: "Brands" */
  Brands_stream: Array<Brands>;
  /** An array relationship */
  CollectionDeals: Array<CollectionDeals>;
  /** An aggregate relationship */
  CollectionDeals_aggregate: CollectionDeals_Aggregate;
  /** fetch data from the table: "CollectionDeals" using primary key columns */
  CollectionDeals_by_pk?: Maybe<CollectionDeals>;
  /** fetch data from the table in a streaming manner: "CollectionDeals" */
  CollectionDeals_stream: Array<CollectionDeals>;
  /** fetch data from the table: "Collections" */
  Collections: Array<Collections>;
  /** fetch aggregated fields from the table: "Collections" */
  Collections_aggregate: Collections_Aggregate;
  /** fetch data from the table: "Collections" using primary key columns */
  Collections_by_pk?: Maybe<Collections>;
  /** fetch data from the table in a streaming manner: "Collections" */
  Collections_stream: Array<Collections>;
  /** fetch data from the table: "DealStatus" */
  DealStatus: Array<DealStatus>;
  /** fetch aggregated fields from the table: "DealStatus" */
  DealStatus_aggregate: DealStatus_Aggregate;
  /** fetch data from the table: "DealStatus" using primary key columns */
  DealStatus_by_pk?: Maybe<DealStatus>;
  /** fetch data from the table in a streaming manner: "DealStatus" */
  DealStatus_stream: Array<DealStatus>;
  /** An array relationship */
  Deals: Array<Deals>;
  /** An aggregate relationship */
  Deals_aggregate: Deals_Aggregate;
  /** fetch data from the table: "Deals" using primary key columns */
  Deals_by_pk?: Maybe<Deals>;
  /** fetch data from the table in a streaming manner: "Deals" */
  Deals_stream: Array<Deals>;
  /** fetch data from the table: "PaymentCurrency" */
  PaymentCurrency: Array<PaymentCurrency>;
  /** fetch aggregated fields from the table: "PaymentCurrency" */
  PaymentCurrency_aggregate: PaymentCurrency_Aggregate;
  /** fetch data from the table: "PaymentCurrency" using primary key columns */
  PaymentCurrency_by_pk?: Maybe<PaymentCurrency>;
  /** fetch data from the table in a streaming manner: "PaymentCurrency" */
  PaymentCurrency_stream: Array<PaymentCurrency>;
  /** An array relationship */
  Users: Array<Users>;
  /** fetch data from the table: "UsersRole" */
  UsersRole: Array<UsersRole>;
  /** fetch aggregated fields from the table: "UsersRole" */
  UsersRole_aggregate: UsersRole_Aggregate;
  /** fetch data from the table: "UsersRole" using primary key columns */
  UsersRole_by_pk?: Maybe<UsersRole>;
  /** fetch data from the table in a streaming manner: "UsersRole" */
  UsersRole_stream: Array<UsersRole>;
  /** An aggregate relationship */
  Users_aggregate: Users_Aggregate;
  /** fetch data from the table: "Users" using primary key columns */
  Users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "Users_private" */
  Users_private: Array<Users_Private>;
  /** fetch aggregated fields from the table: "Users_private" */
  Users_private_aggregate: Users_Private_Aggregate;
  /** fetch data from the table in a streaming manner: "Users_private" */
  Users_private_stream: Array<Users_Private>;
  /** fetch data from the table in a streaming manner: "Users" */
  Users_stream: Array<Users>;
};


export type Subscription_RootBidStatusArgs = {
  distinct_on?: InputMaybe<Array<BidStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BidStatus_Order_By>>;
  where?: InputMaybe<BidStatus_Bool_Exp>;
};


export type Subscription_RootBidStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BidStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BidStatus_Order_By>>;
  where?: InputMaybe<BidStatus_Bool_Exp>;
};


export type Subscription_RootBidStatus_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootBidStatus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BidStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<BidStatus_Bool_Exp>;
};


export type Subscription_RootBidsArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Subscription_RootBids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Order_By>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Subscription_RootBids_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBids_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Private_Order_By>>;
  where?: InputMaybe<Bids_Private_Bool_Exp>;
};


export type Subscription_RootBids_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bids_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bids_Private_Order_By>>;
  where?: InputMaybe<Bids_Private_Bool_Exp>;
};


export type Subscription_RootBids_Private_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bids_Private_Stream_Cursor_Input>>;
  where?: InputMaybe<Bids_Private_Bool_Exp>;
};


export type Subscription_RootBids_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bids_Stream_Cursor_Input>>;
  where?: InputMaybe<Bids_Bool_Exp>;
};


export type Subscription_RootBrandsArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Subscription_RootBrands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Order_By>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Subscription_RootBrands_By_PkArgs = {
  wallet_address: Scalars['String'];
};


export type Subscription_RootBrands_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Private_Order_By>>;
  where?: InputMaybe<Brands_Private_Bool_Exp>;
};


export type Subscription_RootBrands_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brands_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brands_Private_Order_By>>;
  where?: InputMaybe<Brands_Private_Bool_Exp>;
};


export type Subscription_RootBrands_Private_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Brands_Private_Stream_Cursor_Input>>;
  where?: InputMaybe<Brands_Private_Bool_Exp>;
};


export type Subscription_RootBrands_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Brands_Stream_Cursor_Input>>;
  where?: InputMaybe<Brands_Bool_Exp>;
};


export type Subscription_RootCollectionDealsArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


export type Subscription_RootCollectionDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CollectionDeals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CollectionDeals_Order_By>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


export type Subscription_RootCollectionDeals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCollectionDeals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CollectionDeals_Stream_Cursor_Input>>;
  where?: InputMaybe<CollectionDeals_Bool_Exp>;
};


export type Subscription_RootCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootCollections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootCollections_By_PkArgs = {
  nft_contract_address: Scalars['String'];
};


export type Subscription_RootCollections_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Collections_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootDealStatusArgs = {
  distinct_on?: InputMaybe<Array<DealStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealStatus_Order_By>>;
  where?: InputMaybe<DealStatus_Bool_Exp>;
};


export type Subscription_RootDealStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DealStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DealStatus_Order_By>>;
  where?: InputMaybe<DealStatus_Bool_Exp>;
};


export type Subscription_RootDealStatus_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDealStatus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DealStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<DealStatus_Bool_Exp>;
};


export type Subscription_RootDealsArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


export type Subscription_RootDeals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deals_Order_By>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


export type Subscription_RootDeals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Deals_Stream_Cursor_Input>>;
  where?: InputMaybe<Deals_Bool_Exp>;
};


export type Subscription_RootPaymentCurrencyArgs = {
  distinct_on?: InputMaybe<Array<PaymentCurrency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentCurrency_Order_By>>;
  where?: InputMaybe<PaymentCurrency_Bool_Exp>;
};


export type Subscription_RootPaymentCurrency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentCurrency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PaymentCurrency_Order_By>>;
  where?: InputMaybe<PaymentCurrency_Bool_Exp>;
};


export type Subscription_RootPaymentCurrency_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPaymentCurrency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentCurrency_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentCurrency_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersRoleArgs = {
  distinct_on?: InputMaybe<Array<UsersRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersRole_Order_By>>;
  where?: InputMaybe<UsersRole_Bool_Exp>;
};


export type Subscription_RootUsersRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersRole_Order_By>>;
  where?: InputMaybe<UsersRole_Bool_Exp>;
};


export type Subscription_RootUsersRole_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUsersRole_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersRole_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersRole_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  wallet_address: Scalars['String'];
};


export type Subscription_RootUsers_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Users_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Private_Order_By>>;
  where?: InputMaybe<Users_Private_Bool_Exp>;
};


export type Subscription_RootUsers_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Private_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Private_Order_By>>;
  where?: InputMaybe<Users_Private_Bool_Exp>;
};


export type Subscription_RootUsers_Private_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Private_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Private_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

export type BidFragment = { __typename?: 'Bids', token_id: string, tx_hash?: string | null, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } };

export type BrandFragment = { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null };

export type CollectionFragment = { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null };

export type DealFragment = { __typename?: 'Deals', wallet_address: string, title: string, id: number, custom_terms?: any | null, license_expiration: any, bidding_expiration: any, min_budget?: string | null, max_budget?: string | null, description?: string | null, payment_currency: PaymentCurrency_Enum, royalty_percentage?: any | null, is_featured: boolean, bonus_config?: any | null, created_at: any, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null, Brands_private_info?: { __typename?: 'Brands_private', physical_address?: string | null } | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }>, Bids_aggregate: { __typename?: 'Bids_aggregate', aggregate?: { __typename?: 'Bids_aggregate_fields', count: number } | null }, executed_bids: Array<{ __typename?: 'Bids', nft_contract_address: string, token_id: string, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null }, Deal: { __typename?: 'Deals', title: string, id: number, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null } } }> };

export type CreateOrUpdateUserMutationVariables = Exact<{
  refresh_token: Scalars['String'];
}>;


export type CreateOrUpdateUserMutation = { __typename?: 'mutation_root', insert_Users_one?: { __typename?: 'Users', wallet_address: string, role?: UsersRole_Enum | null, Brand?: { __typename?: 'Brands', username?: string | null } | null } | null };

export type UpdateUserRefreshTokenMutationVariables = Exact<{
  wallet_address: Scalars['String'];
}>;


export type UpdateUserRefreshTokenMutation = { __typename?: 'mutation_root', update_Users_by_pk?: { __typename?: 'Users', refresh_token?: string | null } | null };

export type GetCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsQuery = { __typename?: 'query_root', Collections: Array<{ __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null }> };

export type GetDealProposalLicensedQueryVariables = Exact<{
  dealId: Scalars['Int'];
  bidId: Scalars['Int'];
}>;


export type GetDealProposalLicensedQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', Bids: Array<{ __typename?: 'Bids', nft_contract_address: string, token_id: string, bid_amount: string, Collection: { __typename?: 'Collections', name?: string | null }, Deal: { __typename?: 'Deals', title: string, payment_currency: PaymentCurrency_Enum, Brand: { __typename?: 'Brands', company_name?: string | null } }, User: { __typename?: 'Users', username?: string | null, wallet_address: string } }> } | null };

export type GetDealProposalQueryVariables = Exact<{
  dealId: Scalars['Int'];
  bidId: Scalars['Int'];
}>;


export type GetDealProposalQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', Bids: Array<{ __typename?: 'Bids', id: number, nft_contract_address: string, token_id: string, Collection: { __typename?: 'Collections', name?: string | null }, Deal: { __typename?: 'Deals', id: number, title: string, Brand: { __typename?: 'Brands', company_name?: string | null } }, User: { __typename?: 'Users', username?: string | null, wallet_address: string } }> } | null };

export type GetDealsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  dealsWhere?: InputMaybe<Deals_Bool_Exp>;
}>;


export type GetDealsQuery = { __typename?: 'query_root', Deals: Array<{ __typename?: 'Deals', title: string, id: number, license_expiration: any, bidding_expiration: any, min_budget?: string | null, max_budget?: string | null, royalty_percentage?: any | null, wallet_address: string, payment_currency: PaymentCurrency_Enum, is_featured: boolean, bonus_config?: any | null, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }>, Bids_aggregate: { __typename?: 'Bids_aggregate', aggregate?: { __typename?: 'Bids_aggregate_fields', count: number } | null } }> };

export type GetMultipleBidsQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetMultipleBidsQuery = { __typename?: 'query_root', Bids: Array<{ __typename?: 'Bids', id: number, Bids_private_info?: { __typename?: 'Bids_private', agreementHash?: string | null } | null }> };

export type GetSingleBidFromHashQueryVariables = Exact<{
  agreementHash: Scalars['String'];
}>;


export type GetSingleBidFromHashQuery = { __typename?: 'query_root', Bids: Array<{ __typename?: 'Bids', id: number, nft_contract_address: string, token_id: string, bid_amount: string, bid_percentage_amount?: any | null, Collection: { __typename?: 'Collections', name?: string | null, nft_contract_address: string, updated_at: any }, Deal: { __typename?: 'Deals', id: number, title: string, payment_currency: PaymentCurrency_Enum, Brand: { __typename?: 'Brands', company_name?: string | null, username?: string | null, updated_at?: any | null, wallet_address: string } }, User: { __typename?: 'Users', username?: string | null, wallet_address: string }, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null }> };

export type GetSingleDealQueryVariables = Exact<{
  id: Scalars['Int'];
  bids_where?: InputMaybe<Bids_Bool_Exp>;
}>;


export type GetSingleDealQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', id: number, custom_terms?: any | null, wallet_address: string, title: string, license_expiration: any, bidding_expiration: any, min_budget?: string | null, max_budget?: string | null, royalty_percentage?: any | null, bonus_config?: any | null, description?: string | null, payment_currency: PaymentCurrency_Enum, created_at: any, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }>, Bids: Array<{ __typename?: 'Bids', token_id: string, tx_hash?: string | null, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }>, Bids_aggregate: { __typename?: 'Bids_aggregate', aggregate?: { __typename?: 'Bids_aggregate_fields', count: number } | null }, executed_bids: Array<{ __typename?: 'Bids', nft_contract_address: string, token_id: string, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null }, Deal: { __typename?: 'Deals', title: string, id: number, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null } } }> } | null };

export type GetUserByRefreshTokenQueryVariables = Exact<{
  refresh_token: Scalars['String'];
}>;


export type GetUserByRefreshTokenQuery = { __typename?: 'query_root', Users: Array<{ __typename?: 'Users', refresh_token?: string | null, wallet_address: string }> };

export type CreateBidMutationVariables = Exact<{
  object: Bids_Insert_Input;
}>;


export type CreateBidMutation = { __typename?: 'mutation_root', insert_Bids_one?: { __typename?: 'Bids', id: number, deal_id: number, nft_contract_address: string, status: BidStatus_Enum, token_id: string, tx_hash?: string | null, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null } | null };

export type CreateDealMutationVariables = Exact<{
  object: Deals_Insert_Input;
}>;


export type CreateDealMutation = { __typename?: 'mutation_root', insert_Deals_one?: { __typename?: 'Deals', id: number, title: string } | null };

export type DeleteBidMutationVariables = Exact<{
  bidId: Scalars['Int'];
}>;


export type DeleteBidMutation = { __typename?: 'mutation_root', delete_Bids_by_pk?: { __typename?: 'Bids', id: number } | null };

export type ExecuteBidsMutationVariables = Exact<{
  agreementHashes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  status: BidStatus_Enum;
}>;


export type ExecuteBidsMutation = { __typename?: 'mutation_root', update_Bids?: { __typename?: 'Bids_mutation_response', affected_rows: number } | null };

export type UpdateBidMutationVariables = Exact<{
  id: Scalars['Int'];
  status: BidStatus_Enum;
}>;


export type UpdateBidMutation = { __typename?: 'mutation_root', update_Bids_by_pk?: { __typename?: 'Bids', id: number, status: BidStatus_Enum } | null };

export type UpdateBrandMutationVariables = Exact<{
  wallet_address: Scalars['String'];
  object: Brands_Set_Input;
}>;


export type UpdateBrandMutation = { __typename?: 'mutation_root', update_Brands_by_pk?: { __typename?: 'Brands', wallet_address: string, name?: string | null, username?: string | null, Brands_private_info?: { __typename?: 'Brands_private', email?: string | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  wallet_address: Scalars['String'];
  object: Users_Set_Input;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_Users_by_pk?: { __typename?: 'Users', wallet_address: string, name?: string | null, twitter?: string | null, instagram?: string | null } | null };

export type GetBidsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetBidsQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', payment_currency: PaymentCurrency_Enum, Bids: Array<{ __typename?: 'Bids', id: number, nft_contract_address: string, status: BidStatus_Enum, token_id: string, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, agreementHash?: string | null } | null, Collection: { __typename?: 'Collections', name?: string | null } }> } | null };

export type GetBidsForAccountQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type GetBidsForAccountQuery = { __typename?: 'query_root', Users_by_pk?: { __typename?: 'Users', description?: string | null, instagram?: string | null, name?: string | null, twitter?: string | null, wallet_address: string, updated_at: any, executed_bids: Array<{ __typename?: 'Bids', nft_contract_address: string, token_id: string, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null }, Deal: { __typename?: 'Deals', title: string, id: number, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null } } }>, pending_bids: Array<{ __typename?: 'Bids', Deal: { __typename?: 'Deals', title: string, id: number, license_expiration: any, bidding_expiration: any, payment_currency: PaymentCurrency_Enum, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, Bids: Array<{ __typename?: 'Bids', token_id: string, tx_hash?: string | null, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }> } }> } | null };

export type GetBidsForDealQueryVariables = Exact<{
  id: Scalars['Int'];
  bids_where?: InputMaybe<Bids_Bool_Exp>;
}>;


export type GetBidsForDealQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', Bids: Array<{ __typename?: 'Bids', id: number, nft_contract_address: string, status: BidStatus_Enum, token_id: string, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null, User: { __typename?: 'Users', wallet_address: string }, Collection: { __typename?: 'Collections', name?: string | null } }> } | null };

export type GetBidsForDealByCollectionQueryVariables = Exact<{
  id: Scalars['Int'];
  bids_where?: InputMaybe<Bids_Bool_Exp>;
}>;


export type GetBidsForDealByCollectionQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', id: number, Bids: Array<{ __typename?: 'Bids', id: number, nft_contract_address: string, status: BidStatus_Enum, token_id: string, Bids_private_info?: { __typename?: 'Bids_private', agreementHash?: string | null, bid_amount?: string | null, bid_percentage_amount?: any | null } | null, User: { __typename?: 'Users', wallet_address: string }, Collection: { __typename?: 'Collections', name?: string | null } }> } | null };

export type GetBrandByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetBrandByUsernameQuery = { __typename?: 'query_root', Brands: Array<{ __typename?: 'Brands', wallet_address: string, company_name?: string | null, description?: string | null, instagram?: string | null, name?: string | null, position_at_company?: string | null, twitter?: string | null, username?: string | null, website?: string | null, updated_at?: any | null, Brands_private_info?: { __typename?: 'Brands_private', phone?: string | null, email?: string | null } | null }>, Deals: Array<{ __typename?: 'Deals', description?: string | null, id: number, license_expiration: any, max_budget?: string | null, min_budget?: string | null, royalty_percentage?: any | null, payment_currency: PaymentCurrency_Enum, title: string, wallet_address: string, bidding_expiration: any, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, description?: string | null, name?: string | null } }> }>, executed_bids: Array<{ __typename?: 'Bids', nft_contract_address: string, token_id: string, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null }, Deal: { __typename?: 'Deals', title: string, id: number, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null } } }> };

export type GetBrandInfoQueryVariables = Exact<{
  wallet_address: Scalars['String'];
}>;


export type GetBrandInfoQuery = { __typename?: 'query_root', Brands_by_pk?: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, description?: string | null, instagram?: string | null, twitter?: string | null, website?: string | null, name?: string | null, username?: string | null, position_at_company?: string | null, wallet_address: string, updated_at?: any | null, royalty_opp_enabled?: boolean | null, Brands_private_info?: { __typename?: 'Brands_private', physical_address?: string | null, email?: string | null, phone?: string | null } | null } | null };

export type GetBrandPageQueryVariables = Exact<{
  account: Scalars['String'];
}>;


export type GetBrandPageQuery = { __typename?: 'query_root', Brands_by_pk?: { __typename?: 'Brands', wallet_address: string, company_name?: string | null, legal_name?: string | null, description?: string | null, email?: string | null, instagram?: string | null, name?: string | null, phone?: string | null, position_at_company?: string | null, twitter?: string | null, username?: string | null, website?: string | null, Deals: Array<{ __typename?: 'Deals', description?: string | null, id: number, license_expiration: any, max_budget?: string | null, min_budget?: string | null, royalty_percentage?: any | null, payment_currency: PaymentCurrency_Enum, title: string, wallet_address: string, bidding_expiration: any, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }> }>, executed_bids: Array<{ __typename?: 'Deals', id: number, title: string, license_expiration: any, payment_currency: PaymentCurrency_Enum, Brand: { __typename?: 'Brands', company_name?: string | null }, Bids: Array<{ __typename?: 'Bids', token_id: string, tx_hash?: string | null, status: BidStatus_Enum, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, wallet_address?: string | null } | null, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean } }> }> } | null };

export type GetBrandUsernameQueryVariables = Exact<{
  wallet_address: Scalars['String'];
}>;


export type GetBrandUsernameQuery = { __typename?: 'query_root', Brands_by_pk?: { __typename?: 'Brands', username?: string | null } | null };

export type GetDealByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetDealByIdQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', id: number, title: string, license_expiration: any, min_budget?: string | null, max_budget?: string | null, royalty_percentage?: any | null, description?: string | null, payment_currency: PaymentCurrency_Enum, bidding_expiration: any, wallet_address: string, bonus_config?: any | null, created_at: any, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null } }> } | null };

export type GetDealForCreateBidQueryVariables = Exact<{
  id: Scalars['Int'];
  wallet_address: Scalars['String'];
  nft_contract_address: Scalars['String'];
}>;


export type GetDealForCreateBidQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', id: number, status: DealStatus_Enum, min_budget?: string | null, max_budget?: string | null, royalty_percentage?: any | null, payment_currency: PaymentCurrency_Enum, bidding_expiration: any, license_expiration: any, custom_terms?: any | null, CollectionDeals: Array<{ __typename?: 'CollectionDeals', nft_contract_address: string, Collection: { __typename?: 'Collections', name?: string | null } }>, Brand: { __typename?: 'Brands', wallet_address: string }, Bids: Array<{ __typename?: 'Bids', Bids_private_info?: { __typename?: 'Bids_private', id?: number | null } | null }> } | null };

export type GetDealsByCollectionQueryVariables = Exact<{
  nft_contract_address: Scalars['String'];
}>;


export type GetDealsByCollectionQuery = { __typename?: 'query_root', Collections_by_pk?: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, description?: string | null, twitter?: string | null, instagram?: string | null, website?: string | null } | null, Deals: Array<{ __typename?: 'Deals', description?: string | null, id: number, license_expiration: any, max_budget?: string | null, min_budget?: string | null, royalty_percentage?: any | null, payment_currency: PaymentCurrency_Enum, title: string, wallet_address: string, bidding_expiration: any, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null }, CollectionDeals: Array<{ __typename?: 'CollectionDeals', count: number, Collection: { __typename?: 'Collections', nft_contract_address: string, description?: string | null, name?: string | null } }> }>, executed_bids: Array<{ __typename?: 'Bids', nft_contract_address: string, token_id: string, Collection: { __typename?: 'Collections', nft_contract_address: string, name?: string | null, is_verified: boolean, description?: string | null }, Deal: { __typename?: 'Deals', title: string, id: number, Brand: { __typename?: 'Brands', company_name?: string | null, legal_name?: string | null, wallet_address: string, username?: string | null, royalty_opp_enabled?: boolean | null, updated_at?: any | null } } }> };

export type GetSingleBidQueryVariables = Exact<{
  id: Scalars['Int'];
  nft_contract_address: Scalars['String'];
  token_id: Scalars['String'];
}>;


export type GetSingleBidQuery = { __typename?: 'query_root', Deals_by_pk?: { __typename?: 'Deals', payment_currency: PaymentCurrency_Enum, Bids: Array<{ __typename?: 'Bids', id: number, nft_contract_address: string, status: BidStatus_Enum, token_id: string, Bids_private_info?: { __typename?: 'Bids_private', bid_amount?: string | null, bid_percentage_amount?: any | null, agreementHash?: string | null } | null, Collection: { __typename?: 'Collections', name?: string | null } }> } | null };

export type GetUserInfoByPkQueryVariables = Exact<{
  wallet_address: Scalars['String'];
}>;


export type GetUserInfoByPkQuery = { __typename?: 'query_root', Users_by_pk?: { __typename?: 'Users', name?: string | null, wallet_address: string, twitter?: string | null, instagram?: string | null, updated_at: any } | null };

export const CollectionFragmentDoc = gql`
    fragment Collection on Collections {
  nft_contract_address
  name
  is_verified
  description
}
    `;
export const BidFragmentDoc = gql`
    fragment Bid on Bids {
  token_id
  tx_hash
  Bids_private_info {
    bid_amount
    bid_percentage_amount
    agreementHash
  }
  Collection {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export const BrandFragmentDoc = gql`
    fragment Brand on Brands {
  company_name
  legal_name
  wallet_address
  username
  royalty_opp_enabled
  updated_at
}
    `;
export const DealFragmentDoc = gql`
    fragment Deal on Deals {
  Brand {
    ...Brand
    Brands_private_info {
      physical_address
    }
  }
  wallet_address
  title
  id
  custom_terms
  license_expiration
  bidding_expiration
  min_budget
  max_budget
  description
  payment_currency
  royalty_percentage
  is_featured
  bonus_config
  CollectionDeals {
    count
    Collection {
      ...Collection
    }
  }
  Bids_aggregate {
    aggregate {
      count
    }
  }
  executed_bids: Bids(
    order_by: {token_id: asc}
    where: {status: {_eq: EXECUTED}, Deal: {id: {_eq: $id}}}
  ) {
    nft_contract_address
    token_id
    Collection {
      ...Collection
    }
    Deal {
      title
      id
      Brand {
        ...Brand
      }
    }
  }
  created_at
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}`;
export const CreateOrUpdateUserDocument = gql`
    mutation CreateOrUpdateUser($refresh_token: String!) {
  insert_Users_one(
    object: {refresh_token: $refresh_token}
    on_conflict: {constraint: Users_pkey, update_columns: refresh_token}
  ) {
    wallet_address
    role
    Brand {
      username
    }
  }
}
    `;
export type CreateOrUpdateUserMutationFn = Apollo.MutationFunction<CreateOrUpdateUserMutation, CreateOrUpdateUserMutationVariables>;

/**
 * __useCreateOrUpdateUserMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateUserMutation, { data, loading, error }] = useCreateOrUpdateUserMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *   },
 * });
 */
export function useCreateOrUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateUserMutation, CreateOrUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateUserMutation, CreateOrUpdateUserMutationVariables>(CreateOrUpdateUserDocument, options);
      }
export type CreateOrUpdateUserMutationHookResult = ReturnType<typeof useCreateOrUpdateUserMutation>;
export type CreateOrUpdateUserMutationResult = Apollo.MutationResult<CreateOrUpdateUserMutation>;
export type CreateOrUpdateUserMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateUserMutation, CreateOrUpdateUserMutationVariables>;
export const UpdateUserRefreshTokenDocument = gql`
    mutation UpdateUserRefreshToken($wallet_address: String!) {
  update_Users_by_pk(
    pk_columns: {wallet_address: $wallet_address}
    _set: {refresh_token: null}
  ) {
    refresh_token
  }
}
    `;
export type UpdateUserRefreshTokenMutationFn = Apollo.MutationFunction<UpdateUserRefreshTokenMutation, UpdateUserRefreshTokenMutationVariables>;

/**
 * __useUpdateUserRefreshTokenMutation__
 *
 * To run a mutation, you first call `useUpdateUserRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRefreshTokenMutation, { data, loading, error }] = useUpdateUserRefreshTokenMutation({
 *   variables: {
 *      wallet_address: // value for 'wallet_address'
 *   },
 * });
 */
export function useUpdateUserRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRefreshTokenMutation, UpdateUserRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRefreshTokenMutation, UpdateUserRefreshTokenMutationVariables>(UpdateUserRefreshTokenDocument, options);
      }
export type UpdateUserRefreshTokenMutationHookResult = ReturnType<typeof useUpdateUserRefreshTokenMutation>;
export type UpdateUserRefreshTokenMutationResult = Apollo.MutationResult<UpdateUserRefreshTokenMutation>;
export type UpdateUserRefreshTokenMutationOptions = Apollo.BaseMutationOptions<UpdateUserRefreshTokenMutation, UpdateUserRefreshTokenMutationVariables>;
export const GetCollectionsDocument = gql`
    query getCollections {
  Collections {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
      }
export function useGetCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>;
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>;
export type GetCollectionsQueryResult = Apollo.QueryResult<GetCollectionsQuery, GetCollectionsQueryVariables>;
export function refetchGetCollectionsQuery(variables?: GetCollectionsQueryVariables) {
      return { query: GetCollectionsDocument, variables: variables }
    }
export const GetDealProposalLicensedDocument = gql`
    query getDealProposalLicensed($dealId: Int!, $bidId: Int!) {
  Deals_by_pk(id: $dealId) {
    Bids(where: {id: {_eq: $bidId}, status: {_eq: EXECUTED}}) {
      nft_contract_address
      token_id
      bid_amount
      Collection {
        name
      }
      Deal {
        title
        payment_currency
        Brand {
          company_name
        }
      }
      User {
        username
        wallet_address
      }
    }
  }
}
    `;

/**
 * __useGetDealProposalLicensedQuery__
 *
 * To run a query within a React component, call `useGetDealProposalLicensedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealProposalLicensedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealProposalLicensedQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useGetDealProposalLicensedQuery(baseOptions: Apollo.QueryHookOptions<GetDealProposalLicensedQuery, GetDealProposalLicensedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealProposalLicensedQuery, GetDealProposalLicensedQueryVariables>(GetDealProposalLicensedDocument, options);
      }
export function useGetDealProposalLicensedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealProposalLicensedQuery, GetDealProposalLicensedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealProposalLicensedQuery, GetDealProposalLicensedQueryVariables>(GetDealProposalLicensedDocument, options);
        }
export type GetDealProposalLicensedQueryHookResult = ReturnType<typeof useGetDealProposalLicensedQuery>;
export type GetDealProposalLicensedLazyQueryHookResult = ReturnType<typeof useGetDealProposalLicensedLazyQuery>;
export type GetDealProposalLicensedQueryResult = Apollo.QueryResult<GetDealProposalLicensedQuery, GetDealProposalLicensedQueryVariables>;
export function refetchGetDealProposalLicensedQuery(variables: GetDealProposalLicensedQueryVariables) {
      return { query: GetDealProposalLicensedDocument, variables: variables }
    }
export const GetDealProposalDocument = gql`
    query getDealProposal($dealId: Int!, $bidId: Int!) {
  Deals_by_pk(id: $dealId) {
    Bids(where: {id: {_eq: $bidId}, status: {_neq: EXECUTED}}) {
      id
      nft_contract_address
      token_id
      Collection {
        name
      }
      Deal {
        id
        title
        Brand {
          company_name
        }
      }
      User {
        username
        wallet_address
      }
    }
  }
}
    `;

/**
 * __useGetDealProposalQuery__
 *
 * To run a query within a React component, call `useGetDealProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealProposalQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useGetDealProposalQuery(baseOptions: Apollo.QueryHookOptions<GetDealProposalQuery, GetDealProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealProposalQuery, GetDealProposalQueryVariables>(GetDealProposalDocument, options);
      }
export function useGetDealProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealProposalQuery, GetDealProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealProposalQuery, GetDealProposalQueryVariables>(GetDealProposalDocument, options);
        }
export type GetDealProposalQueryHookResult = ReturnType<typeof useGetDealProposalQuery>;
export type GetDealProposalLazyQueryHookResult = ReturnType<typeof useGetDealProposalLazyQuery>;
export type GetDealProposalQueryResult = Apollo.QueryResult<GetDealProposalQuery, GetDealProposalQueryVariables>;
export function refetchGetDealProposalQuery(variables: GetDealProposalQueryVariables) {
      return { query: GetDealProposalDocument, variables: variables }
    }
export const GetDealsDocument = gql`
    query GetDeals($limit: Int, $dealsWhere: Deals_bool_exp) {
  Deals(order_by: {bidding_expiration: asc}, limit: $limit, where: $dealsWhere) {
    Brand {
      ...Brand
    }
    title
    id
    license_expiration
    bidding_expiration
    min_budget
    max_budget
    royalty_percentage
    wallet_address
    payment_currency
    is_featured
    bonus_config
    CollectionDeals {
      count
      Collection {
        ...Collection
      }
    }
    Bids_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}`;

/**
 * __useGetDealsQuery__
 *
 * To run a query within a React component, call `useGetDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      dealsWhere: // value for 'dealsWhere'
 *   },
 * });
 */
export function useGetDealsQuery(baseOptions?: Apollo.QueryHookOptions<GetDealsQuery, GetDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealsQuery, GetDealsQueryVariables>(GetDealsDocument, options);
      }
export function useGetDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealsQuery, GetDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealsQuery, GetDealsQueryVariables>(GetDealsDocument, options);
        }
export type GetDealsQueryHookResult = ReturnType<typeof useGetDealsQuery>;
export type GetDealsLazyQueryHookResult = ReturnType<typeof useGetDealsLazyQuery>;
export type GetDealsQueryResult = Apollo.QueryResult<GetDealsQuery, GetDealsQueryVariables>;
export function refetchGetDealsQuery(variables?: GetDealsQueryVariables) {
      return { query: GetDealsDocument, variables: variables }
    }
export const GetMultipleBidsDocument = gql`
    query getMultipleBids($ids: [Int!]!) {
  Bids(where: {id: {_in: $ids}}) {
    id
    Bids_private_info {
      agreementHash
    }
  }
}
    `;

/**
 * __useGetMultipleBidsQuery__
 *
 * To run a query within a React component, call `useGetMultipleBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleBidsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMultipleBidsQuery(baseOptions: Apollo.QueryHookOptions<GetMultipleBidsQuery, GetMultipleBidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipleBidsQuery, GetMultipleBidsQueryVariables>(GetMultipleBidsDocument, options);
      }
export function useGetMultipleBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipleBidsQuery, GetMultipleBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipleBidsQuery, GetMultipleBidsQueryVariables>(GetMultipleBidsDocument, options);
        }
export type GetMultipleBidsQueryHookResult = ReturnType<typeof useGetMultipleBidsQuery>;
export type GetMultipleBidsLazyQueryHookResult = ReturnType<typeof useGetMultipleBidsLazyQuery>;
export type GetMultipleBidsQueryResult = Apollo.QueryResult<GetMultipleBidsQuery, GetMultipleBidsQueryVariables>;
export function refetchGetMultipleBidsQuery(variables: GetMultipleBidsQueryVariables) {
      return { query: GetMultipleBidsDocument, variables: variables }
    }
export const GetSingleBidFromHashDocument = gql`
    query getSingleBidFromHash($agreementHash: String!) {
  Bids(where: {Bids_private_info: {agreementHash: {_eq: $agreementHash}}}) {
    id
    nft_contract_address
    token_id
    bid_amount
    bid_percentage_amount
    Collection {
      name
      nft_contract_address
      updated_at
    }
    Deal {
      id
      title
      payment_currency
      Brand {
        company_name
        username
        updated_at
        wallet_address
      }
    }
    User {
      username
      wallet_address
    }
    Bids_private_info {
      bid_amount
      bid_percentage_amount
      agreementHash
    }
  }
}
    `;

/**
 * __useGetSingleBidFromHashQuery__
 *
 * To run a query within a React component, call `useGetSingleBidFromHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBidFromHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBidFromHashQuery({
 *   variables: {
 *      agreementHash: // value for 'agreementHash'
 *   },
 * });
 */
export function useGetSingleBidFromHashQuery(baseOptions: Apollo.QueryHookOptions<GetSingleBidFromHashQuery, GetSingleBidFromHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleBidFromHashQuery, GetSingleBidFromHashQueryVariables>(GetSingleBidFromHashDocument, options);
      }
export function useGetSingleBidFromHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleBidFromHashQuery, GetSingleBidFromHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleBidFromHashQuery, GetSingleBidFromHashQueryVariables>(GetSingleBidFromHashDocument, options);
        }
export type GetSingleBidFromHashQueryHookResult = ReturnType<typeof useGetSingleBidFromHashQuery>;
export type GetSingleBidFromHashLazyQueryHookResult = ReturnType<typeof useGetSingleBidFromHashLazyQuery>;
export type GetSingleBidFromHashQueryResult = Apollo.QueryResult<GetSingleBidFromHashQuery, GetSingleBidFromHashQueryVariables>;
export function refetchGetSingleBidFromHashQuery(variables: GetSingleBidFromHashQueryVariables) {
      return { query: GetSingleBidFromHashDocument, variables: variables }
    }
export const GetSingleDealDocument = gql`
    query GetSingleDeal($id: Int!, $bids_where: Bids_bool_exp) {
  Deals_by_pk(id: $id) {
    id
    custom_terms
    wallet_address
    Brand {
      ...Brand
    }
    title
    license_expiration
    bidding_expiration
    min_budget
    max_budget
    royalty_percentage
    bonus_config
    description
    payment_currency
    CollectionDeals {
      count
      Collection {
        ...Collection
      }
    }
    Bids(where: $bids_where) {
      ...Bid
    }
    Bids_aggregate {
      aggregate {
        count
      }
    }
    executed_bids: Bids(
      order_by: {token_id: asc}
      where: {status: {_eq: EXECUTED}, Deal: {id: {_eq: $id}}}
    ) {
      nft_contract_address
      token_id
      Collection {
        ...Collection
      }
      Deal {
        title
        id
        Brand {
          ...Brand
        }
      }
    }
    created_at
  }
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}
${BidFragmentDoc}`;

/**
 * __useGetSingleDealQuery__
 *
 * To run a query within a React component, call `useGetSingleDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bids_where: // value for 'bids_where'
 *   },
 * });
 */
export function useGetSingleDealQuery(baseOptions: Apollo.QueryHookOptions<GetSingleDealQuery, GetSingleDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleDealQuery, GetSingleDealQueryVariables>(GetSingleDealDocument, options);
      }
export function useGetSingleDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleDealQuery, GetSingleDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleDealQuery, GetSingleDealQueryVariables>(GetSingleDealDocument, options);
        }
export type GetSingleDealQueryHookResult = ReturnType<typeof useGetSingleDealQuery>;
export type GetSingleDealLazyQueryHookResult = ReturnType<typeof useGetSingleDealLazyQuery>;
export type GetSingleDealQueryResult = Apollo.QueryResult<GetSingleDealQuery, GetSingleDealQueryVariables>;
export function refetchGetSingleDealQuery(variables: GetSingleDealQueryVariables) {
      return { query: GetSingleDealDocument, variables: variables }
    }
export const GetUserByRefreshTokenDocument = gql`
    query GetUserByRefreshToken($refresh_token: String!) {
  Users(where: {refresh_token: {_eq: $refresh_token}}) {
    refresh_token
    wallet_address
  }
}
    `;

/**
 * __useGetUserByRefreshTokenQuery__
 *
 * To run a query within a React component, call `useGetUserByRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByRefreshTokenQuery({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *   },
 * });
 */
export function useGetUserByRefreshTokenQuery(baseOptions: Apollo.QueryHookOptions<GetUserByRefreshTokenQuery, GetUserByRefreshTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByRefreshTokenQuery, GetUserByRefreshTokenQueryVariables>(GetUserByRefreshTokenDocument, options);
      }
export function useGetUserByRefreshTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByRefreshTokenQuery, GetUserByRefreshTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByRefreshTokenQuery, GetUserByRefreshTokenQueryVariables>(GetUserByRefreshTokenDocument, options);
        }
export type GetUserByRefreshTokenQueryHookResult = ReturnType<typeof useGetUserByRefreshTokenQuery>;
export type GetUserByRefreshTokenLazyQueryHookResult = ReturnType<typeof useGetUserByRefreshTokenLazyQuery>;
export type GetUserByRefreshTokenQueryResult = Apollo.QueryResult<GetUserByRefreshTokenQuery, GetUserByRefreshTokenQueryVariables>;
export function refetchGetUserByRefreshTokenQuery(variables: GetUserByRefreshTokenQueryVariables) {
      return { query: GetUserByRefreshTokenDocument, variables: variables }
    }
export const CreateBidDocument = gql`
    mutation CreateBid($object: Bids_insert_input!) {
  insert_Bids_one(object: $object) {
    id
    deal_id
    nft_contract_address
    status
    token_id
    tx_hash
    Bids_private_info {
      bid_amount
      bid_percentage_amount
      agreementHash
    }
  }
}
    `;
export type CreateBidMutationFn = Apollo.MutationFunction<CreateBidMutation, CreateBidMutationVariables>;

/**
 * __useCreateBidMutation__
 *
 * To run a mutation, you first call `useCreateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBidMutation, { data, loading, error }] = useCreateBidMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateBidMutation(baseOptions?: Apollo.MutationHookOptions<CreateBidMutation, CreateBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBidMutation, CreateBidMutationVariables>(CreateBidDocument, options);
      }
export type CreateBidMutationHookResult = ReturnType<typeof useCreateBidMutation>;
export type CreateBidMutationResult = Apollo.MutationResult<CreateBidMutation>;
export type CreateBidMutationOptions = Apollo.BaseMutationOptions<CreateBidMutation, CreateBidMutationVariables>;
export const CreateDealDocument = gql`
    mutation CreateDeal($object: Deals_insert_input!) {
  insert_Deals_one(object: $object) {
    id
    title
  }
}
    `;
export type CreateDealMutationFn = Apollo.MutationFunction<CreateDealMutation, CreateDealMutationVariables>;

/**
 * __useCreateDealMutation__
 *
 * To run a mutation, you first call `useCreateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealMutation, { data, loading, error }] = useCreateDealMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateDealMutation(baseOptions?: Apollo.MutationHookOptions<CreateDealMutation, CreateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDealMutation, CreateDealMutationVariables>(CreateDealDocument, options);
      }
export type CreateDealMutationHookResult = ReturnType<typeof useCreateDealMutation>;
export type CreateDealMutationResult = Apollo.MutationResult<CreateDealMutation>;
export type CreateDealMutationOptions = Apollo.BaseMutationOptions<CreateDealMutation, CreateDealMutationVariables>;
export const DeleteBidDocument = gql`
    mutation DeleteBid($bidId: Int!) {
  delete_Bids_by_pk(id: $bidId) {
    id
  }
}
    `;
export type DeleteBidMutationFn = Apollo.MutationFunction<DeleteBidMutation, DeleteBidMutationVariables>;

/**
 * __useDeleteBidMutation__
 *
 * To run a mutation, you first call `useDeleteBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBidMutation, { data, loading, error }] = useDeleteBidMutation({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useDeleteBidMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBidMutation, DeleteBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBidMutation, DeleteBidMutationVariables>(DeleteBidDocument, options);
      }
export type DeleteBidMutationHookResult = ReturnType<typeof useDeleteBidMutation>;
export type DeleteBidMutationResult = Apollo.MutationResult<DeleteBidMutation>;
export type DeleteBidMutationOptions = Apollo.BaseMutationOptions<DeleteBidMutation, DeleteBidMutationVariables>;
export const ExecuteBidsDocument = gql`
    mutation ExecuteBids($agreementHashes: [String!], $status: BidStatus_enum!) {
  update_Bids(
    _set: {status: $status}
    where: {_and: {status: {_neq: EXECUTED}, Bids_private_info: {agreementHash: {_in: $agreementHashes}}}}
  ) {
    affected_rows
  }
}
    `;
export type ExecuteBidsMutationFn = Apollo.MutationFunction<ExecuteBidsMutation, ExecuteBidsMutationVariables>;

/**
 * __useExecuteBidsMutation__
 *
 * To run a mutation, you first call `useExecuteBidsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteBidsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeBidsMutation, { data, loading, error }] = useExecuteBidsMutation({
 *   variables: {
 *      agreementHashes: // value for 'agreementHashes'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useExecuteBidsMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteBidsMutation, ExecuteBidsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteBidsMutation, ExecuteBidsMutationVariables>(ExecuteBidsDocument, options);
      }
export type ExecuteBidsMutationHookResult = ReturnType<typeof useExecuteBidsMutation>;
export type ExecuteBidsMutationResult = Apollo.MutationResult<ExecuteBidsMutation>;
export type ExecuteBidsMutationOptions = Apollo.BaseMutationOptions<ExecuteBidsMutation, ExecuteBidsMutationVariables>;
export const UpdateBidDocument = gql`
    mutation UpdateBid($id: Int!, $status: BidStatus_enum!) {
  update_Bids_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
    status
  }
}
    `;
export type UpdateBidMutationFn = Apollo.MutationFunction<UpdateBidMutation, UpdateBidMutationVariables>;

/**
 * __useUpdateBidMutation__
 *
 * To run a mutation, you first call `useUpdateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBidMutation, { data, loading, error }] = useUpdateBidMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateBidMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBidMutation, UpdateBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBidMutation, UpdateBidMutationVariables>(UpdateBidDocument, options);
      }
export type UpdateBidMutationHookResult = ReturnType<typeof useUpdateBidMutation>;
export type UpdateBidMutationResult = Apollo.MutationResult<UpdateBidMutation>;
export type UpdateBidMutationOptions = Apollo.BaseMutationOptions<UpdateBidMutation, UpdateBidMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($wallet_address: String!, $object: Brands_set_input!) {
  update_Brands_by_pk(
    pk_columns: {wallet_address: $wallet_address}
    _set: $object
  ) {
    wallet_address
    name
    username
    Brands_private_info {
      email
    }
  }
}
    `;
export type UpdateBrandMutationFn = Apollo.MutationFunction<UpdateBrandMutation, UpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      wallet_address: // value for 'wallet_address'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($wallet_address: String!, $object: Users_set_input!) {
  update_Users_by_pk(pk_columns: {wallet_address: $wallet_address}, _set: $object) {
    wallet_address
    name
    twitter
    instagram
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      wallet_address: // value for 'wallet_address'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetBidsDocument = gql`
    query GetBids($id: Int!) {
  Deals_by_pk(id: $id) {
    payment_currency
    Bids {
      id
      nft_contract_address
      status
      token_id
      Bids_private_info {
        bid_amount
        agreementHash
      }
      Collection {
        name
      }
    }
  }
}
    `;

/**
 * __useGetBidsQuery__
 *
 * To run a query within a React component, call `useGetBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBidsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBidsQuery(baseOptions: Apollo.QueryHookOptions<GetBidsQuery, GetBidsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBidsQuery, GetBidsQueryVariables>(GetBidsDocument, options);
      }
export function useGetBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBidsQuery, GetBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBidsQuery, GetBidsQueryVariables>(GetBidsDocument, options);
        }
export type GetBidsQueryHookResult = ReturnType<typeof useGetBidsQuery>;
export type GetBidsLazyQueryHookResult = ReturnType<typeof useGetBidsLazyQuery>;
export type GetBidsQueryResult = Apollo.QueryResult<GetBidsQuery, GetBidsQueryVariables>;
export function refetchGetBidsQuery(variables: GetBidsQueryVariables) {
      return { query: GetBidsDocument, variables: variables }
    }
export const GetBidsForAccountDocument = gql`
    query GetBidsForAccount($address: String!) {
  Users_by_pk(wallet_address: $address) {
    description
    instagram
    name
    twitter
    wallet_address
    updated_at
    executed_bids: Bids(order_by: {deal_id: desc}, where: {status: {_eq: EXECUTED}}) {
      nft_contract_address
      token_id
      Collection {
        ...Collection
      }
      Deal {
        title
        id
        Brand {
          ...Brand
        }
      }
    }
    pending_bids: Bids(
      distinct_on: deal_id
      where: {status: {_nin: [EXECUTED, EXPIRED]}}
    ) {
      Deal {
        title
        id
        license_expiration
        bidding_expiration
        payment_currency
        Brand {
          ...Brand
        }
        Bids(
          order_by: {deal_id: desc}
          where: {User: {wallet_address: {_eq: $address}}, status: {_neq: EXECUTED}}
        ) {
          ...Bid
        }
      }
    }
  }
}
    ${CollectionFragmentDoc}
${BrandFragmentDoc}
${BidFragmentDoc}`;

/**
 * __useGetBidsForAccountQuery__
 *
 * To run a query within a React component, call `useGetBidsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBidsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBidsForAccountQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetBidsForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetBidsForAccountQuery, GetBidsForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBidsForAccountQuery, GetBidsForAccountQueryVariables>(GetBidsForAccountDocument, options);
      }
export function useGetBidsForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBidsForAccountQuery, GetBidsForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBidsForAccountQuery, GetBidsForAccountQueryVariables>(GetBidsForAccountDocument, options);
        }
export type GetBidsForAccountQueryHookResult = ReturnType<typeof useGetBidsForAccountQuery>;
export type GetBidsForAccountLazyQueryHookResult = ReturnType<typeof useGetBidsForAccountLazyQuery>;
export type GetBidsForAccountQueryResult = Apollo.QueryResult<GetBidsForAccountQuery, GetBidsForAccountQueryVariables>;
export function refetchGetBidsForAccountQuery(variables: GetBidsForAccountQueryVariables) {
      return { query: GetBidsForAccountDocument, variables: variables }
    }
export const GetBidsForDealDocument = gql`
    query getBidsForDeal($id: Int!, $bids_where: Bids_bool_exp) {
  Deals_by_pk(id: $id) {
    Bids(where: $bids_where) {
      id
      nft_contract_address
      status
      token_id
      Bids_private_info {
        bid_amount
        bid_percentage_amount
        agreementHash
      }
      User {
        wallet_address
      }
      Collection {
        name
      }
    }
  }
}
    `;

/**
 * __useGetBidsForDealQuery__
 *
 * To run a query within a React component, call `useGetBidsForDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBidsForDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBidsForDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bids_where: // value for 'bids_where'
 *   },
 * });
 */
export function useGetBidsForDealQuery(baseOptions: Apollo.QueryHookOptions<GetBidsForDealQuery, GetBidsForDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBidsForDealQuery, GetBidsForDealQueryVariables>(GetBidsForDealDocument, options);
      }
export function useGetBidsForDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBidsForDealQuery, GetBidsForDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBidsForDealQuery, GetBidsForDealQueryVariables>(GetBidsForDealDocument, options);
        }
export type GetBidsForDealQueryHookResult = ReturnType<typeof useGetBidsForDealQuery>;
export type GetBidsForDealLazyQueryHookResult = ReturnType<typeof useGetBidsForDealLazyQuery>;
export type GetBidsForDealQueryResult = Apollo.QueryResult<GetBidsForDealQuery, GetBidsForDealQueryVariables>;
export function refetchGetBidsForDealQuery(variables: GetBidsForDealQueryVariables) {
      return { query: GetBidsForDealDocument, variables: variables }
    }
export const GetBidsForDealByCollectionDocument = gql`
    query getBidsForDealByCollection($id: Int!, $bids_where: Bids_bool_exp) {
  Deals_by_pk(id: $id) {
    id
    Bids(where: $bids_where) {
      id
      nft_contract_address
      status
      token_id
      Bids_private_info {
        agreementHash
        bid_amount
        bid_percentage_amount
      }
      User {
        wallet_address
      }
      Collection {
        name
      }
    }
  }
}
    `;

/**
 * __useGetBidsForDealByCollectionQuery__
 *
 * To run a query within a React component, call `useGetBidsForDealByCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBidsForDealByCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBidsForDealByCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bids_where: // value for 'bids_where'
 *   },
 * });
 */
export function useGetBidsForDealByCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetBidsForDealByCollectionQuery, GetBidsForDealByCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBidsForDealByCollectionQuery, GetBidsForDealByCollectionQueryVariables>(GetBidsForDealByCollectionDocument, options);
      }
export function useGetBidsForDealByCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBidsForDealByCollectionQuery, GetBidsForDealByCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBidsForDealByCollectionQuery, GetBidsForDealByCollectionQueryVariables>(GetBidsForDealByCollectionDocument, options);
        }
export type GetBidsForDealByCollectionQueryHookResult = ReturnType<typeof useGetBidsForDealByCollectionQuery>;
export type GetBidsForDealByCollectionLazyQueryHookResult = ReturnType<typeof useGetBidsForDealByCollectionLazyQuery>;
export type GetBidsForDealByCollectionQueryResult = Apollo.QueryResult<GetBidsForDealByCollectionQuery, GetBidsForDealByCollectionQueryVariables>;
export function refetchGetBidsForDealByCollectionQuery(variables: GetBidsForDealByCollectionQueryVariables) {
      return { query: GetBidsForDealByCollectionDocument, variables: variables }
    }
export const GetBrandByUsernameDocument = gql`
    query GetBrandByUsername($username: String!) {
  Brands(where: {username: {_eq: $username}}) {
    wallet_address
    company_name
    description
    instagram
    name
    position_at_company
    twitter
    username
    website
    updated_at
    Brands_private_info {
      phone
      email
    }
  }
  Deals(
    where: {Brand: {username: {_eq: $username}}}
    order_by: {bidding_expiration: asc}
  ) {
    Brand {
      ...Brand
    }
    description
    id
    license_expiration
    max_budget
    min_budget
    royalty_percentage
    payment_currency
    title
    wallet_address
    bidding_expiration
    CollectionDeals {
      count
      Collection {
        nft_contract_address
        description
        name
      }
    }
  }
  executed_bids: Bids(
    order_by: {deal_id: desc}
    where: {status: {_eq: EXECUTED}, Deal: {Brand: {username: {_eq: $username}}}}
  ) {
    nft_contract_address
    token_id
    Collection {
      ...Collection
    }
    Deal {
      title
      id
      Brand {
        ...Brand
      }
    }
  }
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}`;

/**
 * __useGetBrandByUsernameQuery__
 *
 * To run a query within a React component, call `useGetBrandByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetBrandByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetBrandByUsernameQuery, GetBrandByUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandByUsernameQuery, GetBrandByUsernameQueryVariables>(GetBrandByUsernameDocument, options);
      }
export function useGetBrandByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandByUsernameQuery, GetBrandByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandByUsernameQuery, GetBrandByUsernameQueryVariables>(GetBrandByUsernameDocument, options);
        }
export type GetBrandByUsernameQueryHookResult = ReturnType<typeof useGetBrandByUsernameQuery>;
export type GetBrandByUsernameLazyQueryHookResult = ReturnType<typeof useGetBrandByUsernameLazyQuery>;
export type GetBrandByUsernameQueryResult = Apollo.QueryResult<GetBrandByUsernameQuery, GetBrandByUsernameQueryVariables>;
export function refetchGetBrandByUsernameQuery(variables: GetBrandByUsernameQueryVariables) {
      return { query: GetBrandByUsernameDocument, variables: variables }
    }
export const GetBrandInfoDocument = gql`
    query GetBrandInfo($wallet_address: String!) {
  Brands_by_pk(wallet_address: $wallet_address) {
    company_name
    legal_name
    description
    instagram
    twitter
    website
    name
    username
    position_at_company
    wallet_address
    updated_at
    royalty_opp_enabled
    Brands_private_info {
      physical_address
      email
      phone
    }
  }
}
    `;

/**
 * __useGetBrandInfoQuery__
 *
 * To run a query within a React component, call `useGetBrandInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandInfoQuery({
 *   variables: {
 *      wallet_address: // value for 'wallet_address'
 *   },
 * });
 */
export function useGetBrandInfoQuery(baseOptions: Apollo.QueryHookOptions<GetBrandInfoQuery, GetBrandInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandInfoQuery, GetBrandInfoQueryVariables>(GetBrandInfoDocument, options);
      }
export function useGetBrandInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandInfoQuery, GetBrandInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandInfoQuery, GetBrandInfoQueryVariables>(GetBrandInfoDocument, options);
        }
export type GetBrandInfoQueryHookResult = ReturnType<typeof useGetBrandInfoQuery>;
export type GetBrandInfoLazyQueryHookResult = ReturnType<typeof useGetBrandInfoLazyQuery>;
export type GetBrandInfoQueryResult = Apollo.QueryResult<GetBrandInfoQuery, GetBrandInfoQueryVariables>;
export function refetchGetBrandInfoQuery(variables: GetBrandInfoQueryVariables) {
      return { query: GetBrandInfoDocument, variables: variables }
    }
export const GetBrandPageDocument = gql`
    query GetBrandPage($account: String!) {
  Brands_by_pk(wallet_address: $account) {
    wallet_address
    company_name
    legal_name
    description
    email
    instagram
    name
    phone
    position_at_company
    twitter
    username
    website
    Deals(distinct_on: id) {
      Brand {
        ...Brand
      }
      description
      id
      license_expiration
      max_budget
      min_budget
      royalty_percentage
      payment_currency
      title
      wallet_address
      bidding_expiration
      CollectionDeals {
        count
        Collection {
          ...Collection
        }
      }
    }
    executed_bids: Deals(where: {Bids: {status: {_eq: EXECUTED}}}) {
      id
      title
      license_expiration
      payment_currency
      Brand {
        company_name
      }
      Bids(where: {status: {_in: EXECUTED}}) {
        token_id
        tx_hash
        Bids_private_info {
          bid_amount
          bid_percentage_amount
          wallet_address
        }
        Collection {
          nft_contract_address
          name
          is_verified
        }
        status
      }
    }
  }
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}`;

/**
 * __useGetBrandPageQuery__
 *
 * To run a query within a React component, call `useGetBrandPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandPageQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useGetBrandPageQuery(baseOptions: Apollo.QueryHookOptions<GetBrandPageQuery, GetBrandPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandPageQuery, GetBrandPageQueryVariables>(GetBrandPageDocument, options);
      }
export function useGetBrandPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandPageQuery, GetBrandPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandPageQuery, GetBrandPageQueryVariables>(GetBrandPageDocument, options);
        }
export type GetBrandPageQueryHookResult = ReturnType<typeof useGetBrandPageQuery>;
export type GetBrandPageLazyQueryHookResult = ReturnType<typeof useGetBrandPageLazyQuery>;
export type GetBrandPageQueryResult = Apollo.QueryResult<GetBrandPageQuery, GetBrandPageQueryVariables>;
export function refetchGetBrandPageQuery(variables: GetBrandPageQueryVariables) {
      return { query: GetBrandPageDocument, variables: variables }
    }
export const GetBrandUsernameDocument = gql`
    query GetBrandUsername($wallet_address: String!) {
  Brands_by_pk(wallet_address: $wallet_address) {
    username
  }
}
    `;

/**
 * __useGetBrandUsernameQuery__
 *
 * To run a query within a React component, call `useGetBrandUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandUsernameQuery({
 *   variables: {
 *      wallet_address: // value for 'wallet_address'
 *   },
 * });
 */
export function useGetBrandUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetBrandUsernameQuery, GetBrandUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandUsernameQuery, GetBrandUsernameQueryVariables>(GetBrandUsernameDocument, options);
      }
export function useGetBrandUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandUsernameQuery, GetBrandUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandUsernameQuery, GetBrandUsernameQueryVariables>(GetBrandUsernameDocument, options);
        }
export type GetBrandUsernameQueryHookResult = ReturnType<typeof useGetBrandUsernameQuery>;
export type GetBrandUsernameLazyQueryHookResult = ReturnType<typeof useGetBrandUsernameLazyQuery>;
export type GetBrandUsernameQueryResult = Apollo.QueryResult<GetBrandUsernameQuery, GetBrandUsernameQueryVariables>;
export function refetchGetBrandUsernameQuery(variables: GetBrandUsernameQueryVariables) {
      return { query: GetBrandUsernameDocument, variables: variables }
    }
export const GetDealByIdDocument = gql`
    query getDealById($id: Int!) {
  Deals_by_pk(id: $id) {
    Brand {
      ...Brand
    }
    id
    title
    license_expiration
    min_budget
    max_budget
    royalty_percentage
    description
    payment_currency
    bidding_expiration
    wallet_address
    bonus_config
    CollectionDeals {
      count
      Collection {
        ...Collection
      }
    }
    created_at
  }
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}`;

/**
 * __useGetDealByIdQuery__
 *
 * To run a query within a React component, call `useGetDealByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDealByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDealByIdQuery, GetDealByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealByIdQuery, GetDealByIdQueryVariables>(GetDealByIdDocument, options);
      }
export function useGetDealByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealByIdQuery, GetDealByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealByIdQuery, GetDealByIdQueryVariables>(GetDealByIdDocument, options);
        }
export type GetDealByIdQueryHookResult = ReturnType<typeof useGetDealByIdQuery>;
export type GetDealByIdLazyQueryHookResult = ReturnType<typeof useGetDealByIdLazyQuery>;
export type GetDealByIdQueryResult = Apollo.QueryResult<GetDealByIdQuery, GetDealByIdQueryVariables>;
export function refetchGetDealByIdQuery(variables: GetDealByIdQueryVariables) {
      return { query: GetDealByIdDocument, variables: variables }
    }
export const GetDealForCreateBidDocument = gql`
    query GetDealForCreateBid($id: Int!, $wallet_address: String!, $nft_contract_address: String!) {
  Deals_by_pk(id: $id) {
    id
    status
    min_budget
    max_budget
    royalty_percentage
    payment_currency
    bidding_expiration
    license_expiration
    CollectionDeals(where: {nft_contract_address: {_eq: $nft_contract_address}}) {
      nft_contract_address
      Collection {
        name
      }
    }
    Brand {
      wallet_address
    }
    custom_terms
    Bids(where: {User: {wallet_address: {_eq: $wallet_address}}}) {
      Bids_private_info {
        id
      }
    }
  }
}
    `;

/**
 * __useGetDealForCreateBidQuery__
 *
 * To run a query within a React component, call `useGetDealForCreateBidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealForCreateBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealForCreateBidQuery({
 *   variables: {
 *      id: // value for 'id'
 *      wallet_address: // value for 'wallet_address'
 *      nft_contract_address: // value for 'nft_contract_address'
 *   },
 * });
 */
export function useGetDealForCreateBidQuery(baseOptions: Apollo.QueryHookOptions<GetDealForCreateBidQuery, GetDealForCreateBidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealForCreateBidQuery, GetDealForCreateBidQueryVariables>(GetDealForCreateBidDocument, options);
      }
export function useGetDealForCreateBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealForCreateBidQuery, GetDealForCreateBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealForCreateBidQuery, GetDealForCreateBidQueryVariables>(GetDealForCreateBidDocument, options);
        }
export type GetDealForCreateBidQueryHookResult = ReturnType<typeof useGetDealForCreateBidQuery>;
export type GetDealForCreateBidLazyQueryHookResult = ReturnType<typeof useGetDealForCreateBidLazyQuery>;
export type GetDealForCreateBidQueryResult = Apollo.QueryResult<GetDealForCreateBidQuery, GetDealForCreateBidQueryVariables>;
export function refetchGetDealForCreateBidQuery(variables: GetDealForCreateBidQueryVariables) {
      return { query: GetDealForCreateBidDocument, variables: variables }
    }
export const GetDealsByCollectionDocument = gql`
    query GetDealsByCollection($nft_contract_address: String!) {
  Collections_by_pk(nft_contract_address: $nft_contract_address) {
    nft_contract_address
    name
    description
    twitter
    instagram
    website
  }
  Deals(
    order_by: {bidding_expiration: asc}
    where: {CollectionDeals: {Collection: {nft_contract_address: {_eq: $nft_contract_address}}}}
  ) {
    Brand {
      ...Brand
    }
    description
    id
    license_expiration
    max_budget
    min_budget
    royalty_percentage
    payment_currency
    title
    wallet_address
    bidding_expiration
    CollectionDeals {
      count
      Collection {
        nft_contract_address
        description
        name
      }
    }
  }
  executed_bids: Bids(
    order_by: {deal_id: desc}
    where: {status: {_eq: EXECUTED}, Collection: {nft_contract_address: {_eq: $nft_contract_address}}}
  ) {
    nft_contract_address
    token_id
    Collection {
      ...Collection
    }
    Deal {
      title
      id
      Brand {
        ...Brand
      }
    }
  }
}
    ${BrandFragmentDoc}
${CollectionFragmentDoc}`;

/**
 * __useGetDealsByCollectionQuery__
 *
 * To run a query within a React component, call `useGetDealsByCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealsByCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealsByCollectionQuery({
 *   variables: {
 *      nft_contract_address: // value for 'nft_contract_address'
 *   },
 * });
 */
export function useGetDealsByCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetDealsByCollectionQuery, GetDealsByCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealsByCollectionQuery, GetDealsByCollectionQueryVariables>(GetDealsByCollectionDocument, options);
      }
export function useGetDealsByCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealsByCollectionQuery, GetDealsByCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealsByCollectionQuery, GetDealsByCollectionQueryVariables>(GetDealsByCollectionDocument, options);
        }
export type GetDealsByCollectionQueryHookResult = ReturnType<typeof useGetDealsByCollectionQuery>;
export type GetDealsByCollectionLazyQueryHookResult = ReturnType<typeof useGetDealsByCollectionLazyQuery>;
export type GetDealsByCollectionQueryResult = Apollo.QueryResult<GetDealsByCollectionQuery, GetDealsByCollectionQueryVariables>;
export function refetchGetDealsByCollectionQuery(variables: GetDealsByCollectionQueryVariables) {
      return { query: GetDealsByCollectionDocument, variables: variables }
    }
export const GetSingleBidDocument = gql`
    query GetSingleBid($id: Int!, $nft_contract_address: String!, $token_id: String!) {
  Deals_by_pk(id: $id) {
    payment_currency
    Bids(
      where: {nft_contract_address: {_eq: $nft_contract_address}, token_id: {_eq: $token_id}}
      limit: 1
    ) {
      id
      nft_contract_address
      status
      token_id
      Bids_private_info {
        bid_amount
        bid_percentage_amount
        agreementHash
      }
      Collection {
        name
      }
    }
  }
}
    `;

/**
 * __useGetSingleBidQuery__
 *
 * To run a query within a React component, call `useGetSingleBidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBidQuery({
 *   variables: {
 *      id: // value for 'id'
 *      nft_contract_address: // value for 'nft_contract_address'
 *      token_id: // value for 'token_id'
 *   },
 * });
 */
export function useGetSingleBidQuery(baseOptions: Apollo.QueryHookOptions<GetSingleBidQuery, GetSingleBidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleBidQuery, GetSingleBidQueryVariables>(GetSingleBidDocument, options);
      }
export function useGetSingleBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleBidQuery, GetSingleBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleBidQuery, GetSingleBidQueryVariables>(GetSingleBidDocument, options);
        }
export type GetSingleBidQueryHookResult = ReturnType<typeof useGetSingleBidQuery>;
export type GetSingleBidLazyQueryHookResult = ReturnType<typeof useGetSingleBidLazyQuery>;
export type GetSingleBidQueryResult = Apollo.QueryResult<GetSingleBidQuery, GetSingleBidQueryVariables>;
export function refetchGetSingleBidQuery(variables: GetSingleBidQueryVariables) {
      return { query: GetSingleBidDocument, variables: variables }
    }
export const GetUserInfoByPkDocument = gql`
    query GetUserInfoByPk($wallet_address: String!) {
  Users_by_pk(wallet_address: $wallet_address) {
    name
    wallet_address
    twitter
    instagram
    updated_at
  }
}
    `;

/**
 * __useGetUserInfoByPkQuery__
 *
 * To run a query within a React component, call `useGetUserInfoByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoByPkQuery({
 *   variables: {
 *      wallet_address: // value for 'wallet_address'
 *   },
 * });
 */
export function useGetUserInfoByPkQuery(baseOptions: Apollo.QueryHookOptions<GetUserInfoByPkQuery, GetUserInfoByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoByPkQuery, GetUserInfoByPkQueryVariables>(GetUserInfoByPkDocument, options);
      }
export function useGetUserInfoByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoByPkQuery, GetUserInfoByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoByPkQuery, GetUserInfoByPkQueryVariables>(GetUserInfoByPkDocument, options);
        }
export type GetUserInfoByPkQueryHookResult = ReturnType<typeof useGetUserInfoByPkQuery>;
export type GetUserInfoByPkLazyQueryHookResult = ReturnType<typeof useGetUserInfoByPkLazyQuery>;
export type GetUserInfoByPkQueryResult = Apollo.QueryResult<GetUserInfoByPkQuery, GetUserInfoByPkQueryVariables>;
export function refetchGetUserInfoByPkQuery(variables: GetUserInfoByPkQueryVariables) {
      return { query: GetUserInfoByPkDocument, variables: variables }
    }